// js.cookie
!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function g(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}return function e(l){function C(e,n,o){var t;if("undefined"!=typeof document){if(1<arguments.length){if("number"==typeof(o=g({path:"/"},C.defaults,o)).expires){var r=new Date;r.setMilliseconds(r.getMilliseconds()+864e5*o.expires),o.expires=r}o.expires=o.expires?o.expires.toUTCString():"";try{t=JSON.stringify(n),/^[\{\[]/.test(t)&&(n=t)}catch(e){}n=l.write?l.write(n,e):encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),e=(e=(e=encodeURIComponent(String(e))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var i="";for(var c in o)o[c]&&(i+="; "+c,!0!==o[c]&&(i+="="+o[c]));return document.cookie=e+"="+n+i}e||(t={});for(var a=document.cookie?document.cookie.split("; "):[],s=/(%[0-9A-Z]{2})+/g,f=0;f<a.length;f++){var p=a[f].split("="),d=p.slice(1).join("=");this.json||'"'!==d.charAt(0)||(d=d.slice(1,-1));try{var u=p[0].replace(s,decodeURIComponent);if(d=l.read?l.read(d,u):l(d,u)||d.replace(s,decodeURIComponent),this.json)try{d=JSON.parse(d)}catch(e){}if(e===u){t=d;break}e||(t[u]=d)}catch(e){}}return t}}return(C.set=C).get=function(e){return C.call(C,e)},C.getJSON=function(){return C.apply({json:!0},[].slice.call(arguments))},C.defaults={},C.remove=function(e,n){C(e,"",g(n,{expires:-1}))},C.withConverter=e,C}(function(){})});

const bod = document.querySelector('body');
if(bod.classList.contains('template-product')) {
  /* jQuery elevateZoom 3.0.8 - Demo's and documentation: - www.elevateweb.co.uk/image-zoom - Copyright (c) 2013 Andrew Eades - www.elevateweb.co.uk - Dual licensed under the LGPL licenses. - http://en.wikipedia.org/wiki/MIT_License - http://en.wikipedia.org/wiki/GNU_General_Public_License */
"function"!==typeof Object.create&&(Object.create=function(d){function h(){}h.prototype=d;return new h});
(function(d,h,l,m){var k={init:function(b,a){var c=this;c.elem=a;c.$elem=d(a);c.imageSrc=c.$elem.data("zoom-image")?c.$elem.data("zoom-image"):c.$elem.attr("src");c.options=d.extend({},d.fn.elevateZoom.options,b);c.options.tint&&(c.options.lensColour="none",c.options.lensOpacity="1");"inner"==c.options.zoomType&&(c.options.showLens=!1);c.$elem.parent().removeAttr("title").removeAttr("alt");c.zoomImage=c.imageSrc;c.refresh(1);d("#"+c.options.gallery+" a").click(function(a){c.options.galleryActiveClass&&
(d("#"+c.options.gallery+" a").removeClass(c.options.galleryActiveClass),d(this).addClass(c.options.galleryActiveClass));a.preventDefault();d(this).data("zoom-image")?c.zoomImagePre=d(this).data("zoom-image"):c.zoomImagePre=d(this).data("image");c.swaptheimage(d(this).data("image"),c.zoomImagePre);return!1})},refresh:function(b){var a=this;setTimeout(function(){a.fetch(a.imageSrc)},b||a.options.refresh)},fetch:function(b){var a=this,c=new Image;c.onload=function(){a.largeWidth=c.width;a.largeHeight=
c.height;a.startZoom();a.currentImage=a.imageSrc;a.options.onZoomedImageLoaded(a.$elem)};c.src=b},startZoom:function(){var b=this;b.nzWidth=b.$elem.width();b.nzHeight=b.$elem.height();b.isWindowActive=!1;b.isLensActive=!1;b.isTintActive=!1;b.overWindow=!1;b.options.imageCrossfade&&(b.zoomWrap=b.$elem.wrap('<div style="height:'+b.nzHeight+"px;width:"+b.nzWidth+'px;" class="zoomWrapper" />'),b.$elem.css("position","absolute"));b.zoomLock=1;b.scrollingLock=!1;b.changeBgSize=!1;b.currentZoomLevel=b.options.zoomLevel;
b.nzOffset=b.$elem.offset();b.widthRatio=b.largeWidth/b.currentZoomLevel/b.nzWidth;b.heightRatio=b.largeHeight/b.currentZoomLevel/b.nzHeight;"window"==b.options.zoomType&&(b.zoomWindowStyle="overflow: hidden;background-position: 0px 0px;text-align:center;background-color: "+String(b.options.zoomWindowBgColour)+";width: "+String(b.options.zoomWindowWidth)+"px;height: "+String(b.options.zoomWindowHeight)+"px;float: left;background-size: "+b.largeWidth/b.currentZoomLevel+"px "+b.largeHeight/b.currentZoomLevel+
"px;display: none;z-index:100;border: "+String(b.options.borderSize)+"px solid "+b.options.borderColour+";background-repeat: no-repeat;position: absolute;");if("inner"==b.options.zoomType){var a=b.$elem.css("border-left-width");b.zoomWindowStyle="overflow: hidden;margin-left: "+String(a)+";margin-top: "+String(a)+";background-position: 0px 0px;width: "+String(b.nzWidth)+"px;height: "+String(b.nzHeight)+"px;float: left;display: none;cursor:"+b.options.cursor+";px solid "+b.options.borderColour+";background-repeat: no-repeat;position: absolute;"}"window"==
b.options.zoomType&&(lensHeight=b.nzHeight<b.options.zoomWindowWidth/b.widthRatio?b.nzHeight:String(b.options.zoomWindowHeight/b.heightRatio),lensWidth=b.largeWidth<b.options.zoomWindowWidth?b.nzWidth:b.options.zoomWindowWidth/b.widthRatio,b.lensStyle="background-position: 0px 0px;width: "+String(b.options.zoomWindowWidth/b.widthRatio)+"px;height: "+String(b.options.zoomWindowHeight/b.heightRatio)+"px;float: right;display: none;overflow: hidden;z-index: 999;-webkit-transform: translateZ(0);opacity:"+
b.options.lensOpacity+";filter: alpha(opacity = "+100*b.options.lensOpacity+"); zoom:1;width:"+lensWidth+"px;height:"+lensHeight+"px;background-color:"+b.options.lensColour+";cursor:"+b.options.cursor+";border: "+b.options.lensBorderSize+"px solid "+b.options.lensBorderColour+";background-repeat: no-repeat;position: absolute;");b.tintStyle="display: block;position: absolute;background-color: "+b.options.tintColour+";filter:alpha(opacity=0);opacity: 0;width: "+b.nzWidth+"px;height: "+b.nzHeight+"px;";
b.lensRound="";"lens"==b.options.zoomType&&(b.lensStyle="background-position: 0px 0px;float: left;display: none;border: "+String(b.options.borderSize)+"px solid "+b.options.borderColour+";width:"+String(b.options.lensSize)+"px;height:"+String(b.options.lensSize)+"px;background-repeat: no-repeat;position: absolute;");"round"==b.options.lensShape&&(b.lensRound="border-top-left-radius: "+String(b.options.lensSize/2+b.options.borderSize)+"px;border-top-right-radius: "+String(b.options.lensSize/2+b.options.borderSize)+
"px;border-bottom-left-radius: "+String(b.options.lensSize/2+b.options.borderSize)+"px;border-bottom-right-radius: "+String(b.options.lensSize/2+b.options.borderSize)+"px;");b.zoomContainer=d('<div class="zoomContainer" style="-webkit-transform: translateZ(0);position:absolute;left:'+b.nzOffset.left+"px;top:"+b.nzOffset.top+"px;height:"+b.nzHeight+"px;width:"+b.nzWidth+'px;"></div>');d("body").append(b.zoomContainer);b.options.containLensZoom&&"lens"==b.options.zoomType&&b.zoomContainer.css("overflow",
"hidden");"inner"!=b.options.zoomType&&(b.zoomLens=d("<div class='zoomLens' style='"+b.lensStyle+b.lensRound+"'>&nbsp;</div>").appendTo(b.zoomContainer).click(function(){b.$elem.trigger("click")}),b.options.tint&&(b.tintContainer=d("<div/>").addClass("tintContainer"),b.zoomTint=d("<div class='zoomTint' style='"+b.tintStyle+"'></div>"),b.zoomLens.wrap(b.tintContainer),b.zoomTintcss=b.zoomLens.after(b.zoomTint),b.zoomTintImage=d('<img style="position: absolute; left: 0px; top: 0px; max-width: none; width: '+
b.nzWidth+"px; height: "+b.nzHeight+'px;" src="'+b.imageSrc+'">').appendTo(b.zoomLens).click(function(){b.$elem.trigger("click")})));isNaN(b.options.zoomWindowPosition)?b.zoomWindow=d("<div style='z-index:999;left:"+b.windowOffsetLeft+"px;top:"+b.windowOffsetTop+"px;"+b.zoomWindowStyle+"' class='zoomWindow'>&nbsp;</div>").appendTo("body").click(function(){b.$elem.trigger("click")}):b.zoomWindow=d("<div style='z-index:999;left:"+b.windowOffsetLeft+"px;top:"+b.windowOffsetTop+"px;"+b.zoomWindowStyle+
"' class='zoomWindow'>&nbsp;</div>").appendTo(b.zoomContainer).click(function(){b.$elem.trigger("click")});b.zoomWindowContainer=d("<div/>").addClass("zoomWindowContainer").css("width",b.options.zoomWindowWidth);b.zoomWindow.wrap(b.zoomWindowContainer);"lens"==b.options.zoomType&&b.zoomLens.css({backgroundImage:"url('"+b.imageSrc+"')"});"window"==b.options.zoomType&&b.zoomWindow.css({backgroundImage:"url('"+b.imageSrc+"')"});"inner"==b.options.zoomType&&b.zoomWindow.css({backgroundImage:"url('"+b.imageSrc+
"')"});b.$elem.bind("touchmove",function(a){a.preventDefault();b.setPosition(a.originalEvent.touches[0]||a.originalEvent.changedTouches[0])});b.zoomContainer.bind("touchmove",function(a){"inner"==b.options.zoomType&&b.showHideWindow("show");a.preventDefault();b.setPosition(a.originalEvent.touches[0]||a.originalEvent.changedTouches[0])});b.zoomContainer.bind("touchend",function(a){b.showHideWindow("hide");b.options.showLens&&b.showHideLens("hide");b.options.tint&&"inner"!=b.options.zoomType&&b.showHideTint("hide")});
b.$elem.bind("touchend",function(a){b.showHideWindow("hide");b.options.showLens&&b.showHideLens("hide");b.options.tint&&"inner"!=b.options.zoomType&&b.showHideTint("hide")});b.options.showLens&&(b.zoomLens.bind("touchmove",function(a){a.preventDefault();b.setPosition(a.originalEvent.touches[0]||a.originalEvent.changedTouches[0])}),b.zoomLens.bind("touchend",function(a){b.showHideWindow("hide");b.options.showLens&&b.showHideLens("hide");b.options.tint&&"inner"!=b.options.zoomType&&b.showHideTint("hide")}));
b.$elem.bind("mousemove",function(a){!1==b.overWindow&&b.setElements("show");if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});b.zoomContainer.bind("mousemove",function(a){!1==b.overWindow&&b.setElements("show");if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});"inner"!=b.options.zoomType&&b.zoomLens.bind("mousemove",function(a){if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),
b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});b.options.tint&&"inner"!=b.options.zoomType&&b.zoomTint.bind("mousemove",function(a){if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});"inner"==b.options.zoomType&&b.zoomWindow.bind("mousemove",function(a){if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});b.zoomContainer.add(b.$elem).mouseenter(function(){!1==b.overWindow&&
b.setElements("show")}).mouseleave(function(){b.scrollLock||b.setElements("hide")});"inner"!=b.options.zoomType&&b.zoomWindow.mouseenter(function(){b.overWindow=!0;b.setElements("hide")}).mouseleave(function(){b.overWindow=!1});b.minZoomLevel=b.options.minZoomLevel?b.options.minZoomLevel:2*b.options.scrollZoomIncrement;b.options.scrollZoom&&b.zoomContainer.add(b.$elem).bind("mousewheel DOMMouseScroll MozMousePixelScroll",function(a){b.scrollLock=!0;clearTimeout(d.data(this,"timer"));d.data(this,"timer",
setTimeout(function(){b.scrollLock=!1},250));var e=a.originalEvent.wheelDelta||-1*a.originalEvent.detail;a.stopImmediatePropagation();a.stopPropagation();a.preventDefault();0<e/120?b.currentZoomLevel>=b.minZoomLevel&&b.changeZoomLevel(b.currentZoomLevel-b.options.scrollZoomIncrement):b.options.maxZoomLevel?b.currentZoomLevel<=b.options.maxZoomLevel&&b.changeZoomLevel(parseFloat(b.currentZoomLevel)+b.options.scrollZoomIncrement):b.changeZoomLevel(parseFloat(b.currentZoomLevel)+b.options.scrollZoomIncrement);
return!1})},setElements:function(b){if(!this.options.zoomEnabled)return!1;"show"==b&&this.isWindowSet&&("inner"==this.options.zoomType&&this.showHideWindow("show"),"window"==this.options.zoomType&&this.showHideWindow("show"),this.options.showLens&&this.showHideLens("show"),this.options.tint&&"inner"!=this.options.zoomType&&this.showHideTint("show"));"hide"==b&&("window"==this.options.zoomType&&this.showHideWindow("hide"),this.options.tint||this.showHideWindow("hide"),this.options.showLens&&this.showHideLens("hide"),
this.options.tint&&this.showHideTint("hide"))},setPosition:function(b){if(!this.options.zoomEnabled)return!1;this.nzHeight=this.$elem.height();this.nzWidth=this.$elem.width();this.nzOffset=this.$elem.offset();this.options.tint&&"inner"!=this.options.zoomType&&(this.zoomTint.css({top:0}),this.zoomTint.css({left:0}));this.options.responsive&&!this.options.scrollZoom&&this.options.showLens&&(lensHeight=this.nzHeight<this.options.zoomWindowWidth/this.widthRatio?this.nzHeight:String(this.options.zoomWindowHeight/
this.heightRatio),lensWidth=this.largeWidth<this.options.zoomWindowWidth?this.nzWidth:this.options.zoomWindowWidth/this.widthRatio,this.widthRatio=this.largeWidth/this.nzWidth,this.heightRatio=this.largeHeight/this.nzHeight,"lens"!=this.options.zoomType&&(lensHeight=this.nzHeight<this.options.zoomWindowWidth/this.widthRatio?this.nzHeight:String(this.options.zoomWindowHeight/this.heightRatio),lensWidth=this.options.zoomWindowWidth<this.options.zoomWindowWidth?this.nzWidth:this.options.zoomWindowWidth/
this.widthRatio,this.zoomLens.css("width",lensWidth),this.zoomLens.css("height",lensHeight),this.options.tint&&(this.zoomTintImage.css("width",this.nzWidth),this.zoomTintImage.css("height",this.nzHeight))),"lens"==this.options.zoomType&&this.zoomLens.css({width:String(this.options.lensSize)+"px",height:String(this.options.lensSize)+"px"}));this.zoomContainer.css({top:this.nzOffset.top});this.zoomContainer.css({left:this.nzOffset.left});this.mouseLeft=parseInt(b.pageX-this.nzOffset.left);this.mouseTop=
parseInt(b.pageY-this.nzOffset.top);"window"==this.options.zoomType&&(this.Etoppos=this.mouseTop<this.zoomLens.height()/2,this.Eboppos=this.mouseTop>this.nzHeight-this.zoomLens.height()/2-2*this.options.lensBorderSize,this.Eloppos=this.mouseLeft<0+this.zoomLens.width()/2,this.Eroppos=this.mouseLeft>this.nzWidth-this.zoomLens.width()/2-2*this.options.lensBorderSize);"inner"==this.options.zoomType&&(this.Etoppos=this.mouseTop<this.nzHeight/2/this.heightRatio,this.Eboppos=this.mouseTop>this.nzHeight-
this.nzHeight/2/this.heightRatio,this.Eloppos=this.mouseLeft<0+this.nzWidth/2/this.widthRatio,this.Eroppos=this.mouseLeft>this.nzWidth-this.nzWidth/2/this.widthRatio-2*this.options.lensBorderSize);0>=this.mouseLeft||0>this.mouseTop||this.mouseLeft>this.nzWidth||this.mouseTop>this.nzHeight?this.setElements("hide"):(this.options.showLens&&(this.lensLeftPos=String(this.mouseLeft-this.zoomLens.width()/2),this.lensTopPos=String(this.mouseTop-this.zoomLens.height()/2)),this.Etoppos&&(this.lensTopPos=0),
this.Eloppos&&(this.tintpos=this.lensLeftPos=this.windowLeftPos=0),"window"==this.options.zoomType&&(this.Eboppos&&(this.lensTopPos=Math.max(this.nzHeight-this.zoomLens.height()-2*this.options.lensBorderSize,0)),this.Eroppos&&(this.lensLeftPos=this.nzWidth-this.zoomLens.width()-2*this.options.lensBorderSize)),"inner"==this.options.zoomType&&(this.Eboppos&&(this.lensTopPos=Math.max(this.nzHeight-2*this.options.lensBorderSize,0)),this.Eroppos&&(this.lensLeftPos=this.nzWidth-this.nzWidth-2*this.options.lensBorderSize)),
"lens"==this.options.zoomType&&(this.windowLeftPos=String(-1*((b.pageX-this.nzOffset.left)*this.widthRatio-this.zoomLens.width()/2)),this.windowTopPos=String(-1*((b.pageY-this.nzOffset.top)*this.heightRatio-this.zoomLens.height()/2)),this.zoomLens.css({backgroundPosition:this.windowLeftPos+"px "+this.windowTopPos+"px"}),this.changeBgSize&&(this.nzHeight>this.nzWidth?("lens"==this.options.zoomType&&this.zoomLens.css({"background-size":this.largeWidth/this.newvalueheight+"px "+this.largeHeight/this.newvalueheight+
"px"}),this.zoomWindow.css({"background-size":this.largeWidth/this.newvalueheight+"px "+this.largeHeight/this.newvalueheight+"px"})):("lens"==this.options.zoomType&&this.zoomLens.css({"background-size":this.largeWidth/this.newvaluewidth+"px "+this.largeHeight/this.newvaluewidth+"px"}),this.zoomWindow.css({"background-size":this.largeWidth/this.newvaluewidth+"px "+this.largeHeight/this.newvaluewidth+"px"})),this.changeBgSize=!1),this.setWindowPostition(b)),this.options.tint&&"inner"!=this.options.zoomType&&
this.setTintPosition(b),"window"==this.options.zoomType&&this.setWindowPostition(b),"inner"==this.options.zoomType&&this.setWindowPostition(b),this.options.showLens&&(this.fullwidth&&"lens"!=this.options.zoomType&&(this.lensLeftPos=0),this.zoomLens.css({left:this.lensLeftPos+"px",top:this.lensTopPos+"px"})))},showHideWindow:function(b){"show"!=b||this.isWindowActive||(this.options.zoomWindowFadeIn?this.zoomWindow.stop(!0,!0,!1).fadeIn(this.options.zoomWindowFadeIn):this.zoomWindow.show(),this.isWindowActive=
!0);"hide"==b&&this.isWindowActive&&(this.options.zoomWindowFadeOut?this.zoomWindow.stop(!0,!0).fadeOut(this.options.zoomWindowFadeOut):this.zoomWindow.hide(),this.isWindowActive=!1)},showHideLens:function(b){"show"!=b||this.isLensActive||(this.options.lensFadeIn?this.zoomLens.stop(!0,!0,!1).fadeIn(this.options.lensFadeIn):this.zoomLens.show(),this.isLensActive=!0);"hide"==b&&this.isLensActive&&(this.options.lensFadeOut?this.zoomLens.stop(!0,!0).fadeOut(this.options.lensFadeOut):this.zoomLens.hide(),
this.isLensActive=!1)},showHideTint:function(b){"show"!=b||this.isTintActive||(this.options.zoomTintFadeIn?this.zoomTint.css({opacity:this.options.tintOpacity}).animate().stop(!0,!0).fadeIn("slow"):(this.zoomTint.css({opacity:this.options.tintOpacity}).animate(),this.zoomTint.show()),this.isTintActive=!0);"hide"==b&&this.isTintActive&&(this.options.zoomTintFadeOut?this.zoomTint.stop(!0,!0).fadeOut(this.options.zoomTintFadeOut):this.zoomTint.hide(),this.isTintActive=!1)},setLensPostition:function(b){},
setWindowPostition:function(b){var a=this;if(isNaN(a.options.zoomWindowPosition))a.externalContainer=d("#"+a.options.zoomWindowPosition),a.externalContainerWidth=a.externalContainer.width(),a.externalContainerHeight=a.externalContainer.height(),a.externalContainerOffset=a.externalContainer.offset(),a.windowOffsetTop=a.externalContainerOffset.top,a.windowOffsetLeft=a.externalContainerOffset.left;else switch(a.options.zoomWindowPosition){case 1:a.windowOffsetTop=a.options.zoomWindowOffety;a.windowOffsetLeft=
+a.nzWidth;break;case 2:a.options.zoomWindowHeight>a.nzHeight&&(a.windowOffsetTop=-1*(a.options.zoomWindowHeight/2-a.nzHeight/2),a.windowOffsetLeft=a.nzWidth);break;case 3:a.windowOffsetTop=a.nzHeight-a.zoomWindow.height()-2*a.options.borderSize;a.windowOffsetLeft=a.nzWidth;break;case 4:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=a.nzWidth;break;case 5:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=a.nzWidth-a.zoomWindow.width()-2*a.options.borderSize;break;case 6:a.options.zoomWindowHeight>
a.nzHeight&&(a.windowOffsetTop=a.nzHeight,a.windowOffsetLeft=-1*(a.options.zoomWindowWidth/2-a.nzWidth/2+2*a.options.borderSize));break;case 7:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=0;break;case 8:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 9:a.windowOffsetTop=a.nzHeight-a.zoomWindow.height()-2*a.options.borderSize;a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 10:a.options.zoomWindowHeight>a.nzHeight&&
(a.windowOffsetTop=-1*(a.options.zoomWindowHeight/2-a.nzHeight/2),a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize));break;case 11:a.windowOffsetTop=a.options.zoomWindowOffety;a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 12:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 13:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=
0;break;case 14:a.options.zoomWindowHeight>a.nzHeight&&(a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize),a.windowOffsetLeft=-1*(a.options.zoomWindowWidth/2-a.nzWidth/2+2*a.options.borderSize));break;case 15:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=a.nzWidth-a.zoomWindow.width()-2*a.options.borderSize;break;case 16:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=a.nzWidth;break;default:a.windowOffsetTop=
a.options.zoomWindowOffety,a.windowOffsetLeft=a.nzWidth}a.isWindowSet=!0;a.windowOffsetTop+=a.options.zoomWindowOffety;a.windowOffsetLeft+=a.options.zoomWindowOffetx;a.zoomWindow.css({top:a.windowOffsetTop});a.zoomWindow.css({left:a.windowOffsetLeft});"inner"==a.options.zoomType&&(a.zoomWindow.css({top:0}),a.zoomWindow.css({left:0}));a.windowLeftPos=String(-1*((b.pageX-a.nzOffset.left)*a.widthRatio-a.zoomWindow.width()/2));a.windowTopPos=String(-1*((b.pageY-a.nzOffset.top)*a.heightRatio-a.zoomWindow.height()/
2));a.Etoppos&&(a.windowTopPos=0);a.Eloppos&&(a.windowLeftPos=0);a.Eboppos&&(a.windowTopPos=-1*(a.largeHeight/a.currentZoomLevel-a.zoomWindow.height()));a.Eroppos&&(a.windowLeftPos=-1*(a.largeWidth/a.currentZoomLevel-a.zoomWindow.width()));a.fullheight&&(a.windowTopPos=0);a.fullwidth&&(a.windowLeftPos=0);if("window"==a.options.zoomType||"inner"==a.options.zoomType)1==a.zoomLock&&(1>=a.widthRatio&&(a.windowLeftPos=0),1>=a.heightRatio&&(a.windowTopPos=0)),a.largeHeight<a.options.zoomWindowHeight&&(a.windowTopPos=
0),a.largeWidth<a.options.zoomWindowWidth&&(a.windowLeftPos=0),a.options.easing?(a.xp||(a.xp=0),a.yp||(a.yp=0),a.loop||(a.loop=setInterval(function(){a.xp+=(a.windowLeftPos-a.xp)/a.options.easingAmount;a.yp+=(a.windowTopPos-a.yp)/a.options.easingAmount;a.scrollingLock?(clearInterval(a.loop),a.xp=a.windowLeftPos,a.yp=a.windowTopPos,a.xp=-1*((b.pageX-a.nzOffset.left)*a.widthRatio-a.zoomWindow.width()/2),a.yp=-1*((b.pageY-a.nzOffset.top)*a.heightRatio-a.zoomWindow.height()/2),a.changeBgSize&&(a.nzHeight>
a.nzWidth?("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"})):("lens"!=a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"})),
a.changeBgSize=!1),a.zoomWindow.css({backgroundPosition:a.windowLeftPos+"px "+a.windowTopPos+"px"}),a.scrollingLock=!1,a.loop=!1):(a.changeBgSize&&(a.nzHeight>a.nzWidth?("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"})):("lens"!=a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvaluewidth+
"px "+a.largeHeight/a.newvaluewidth+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"})),a.changeBgSize=!1),a.zoomWindow.css({backgroundPosition:a.xp+"px "+a.yp+"px"}))},16))):(a.changeBgSize&&(a.nzHeight>a.nzWidth?("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/
a.newvalueheight+"px"})):("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"}),a.largeHeight/a.newvaluewidth<a.options.zoomWindowHeight?a.zoomWindow.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"}):a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"})),a.changeBgSize=!1),a.zoomWindow.css({backgroundPosition:a.windowLeftPos+
"px "+a.windowTopPos+"px"}))},setTintPosition:function(b){this.nzOffset=this.$elem.offset();this.tintpos=String(-1*(b.pageX-this.nzOffset.left-this.zoomLens.width()/2));this.tintposy=String(-1*(b.pageY-this.nzOffset.top-this.zoomLens.height()/2));this.Etoppos&&(this.tintposy=0);this.Eloppos&&(this.tintpos=0);this.Eboppos&&(this.tintposy=-1*(this.nzHeight-this.zoomLens.height()-2*this.options.lensBorderSize));this.Eroppos&&(this.tintpos=-1*(this.nzWidth-this.zoomLens.width()-2*this.options.lensBorderSize));
this.options.tint&&(this.fullheight&&(this.tintposy=0),this.fullwidth&&(this.tintpos=0),this.zoomTintImage.css({left:this.tintpos+"px"}),this.zoomTintImage.css({top:this.tintposy+"px"}))},swaptheimage:function(b,a){var c=this,e=new Image;c.options.loadingIcon&&(c.spinner=d("<div style=\"background: url('"+c.options.loadingIcon+"') no-repeat center;height:"+c.nzHeight+"px;width:"+c.nzWidth+'px;z-index: 2000;position: absolute; background-position: center center;"></div>'),c.$elem.after(c.spinner));
c.options.onImageSwap(c.$elem);e.onload=function(){c.largeWidth=e.width;c.largeHeight=e.height;c.zoomImage=a;c.zoomWindow.css({"background-size":c.largeWidth+"px "+c.largeHeight+"px"});c.zoomWindow.css({"background-size":c.largeWidth+"px "+c.largeHeight+"px"});c.swapAction(b,a)};e.src=a},swapAction:function(b,a){var c=this,e=new Image;e.onload=function(){c.nzHeight=e.height;c.nzWidth=e.width;c.options.onImageSwapComplete(c.$elem);c.doneCallback()};e.src=b;c.currentZoomLevel=c.options.zoomLevel;c.options.maxZoomLevel=
!1;"lens"==c.options.zoomType&&c.zoomLens.css({backgroundImage:"url('"+a+"')"});"window"==c.options.zoomType&&c.zoomWindow.css({backgroundImage:"url('"+a+"')"});"inner"==c.options.zoomType&&c.zoomWindow.css({backgroundImage:"url('"+a+"')"});c.currentImage=a;if(c.options.imageCrossfade){var f=c.$elem,g=f.clone();c.$elem.attr("src",b);c.$elem.after(g);g.stop(!0).fadeOut(c.options.imageCrossfade,function(){d(this).remove()});c.$elem.width("auto").removeAttr("width");c.$elem.height("auto").removeAttr("height");
f.fadeIn(c.options.imageCrossfade);c.options.tint&&"inner"!=c.options.zoomType&&(f=c.zoomTintImage,g=f.clone(),c.zoomTintImage.attr("src",a),c.zoomTintImage.after(g),g.stop(!0).fadeOut(c.options.imageCrossfade,function(){d(this).remove()}),f.fadeIn(c.options.imageCrossfade),c.zoomTint.css({height:c.$elem.height()}),c.zoomTint.css({width:c.$elem.width()}));c.zoomContainer.css("height",c.$elem.height());c.zoomContainer.css("width",c.$elem.width());"inner"!=c.options.zoomType||c.options.constrainType||
(c.zoomWrap.parent().css("height",c.$elem.height()),c.zoomWrap.parent().css("width",c.$elem.width()),c.zoomWindow.css("height",c.$elem.height()),c.zoomWindow.css("width",c.$elem.width()))}else c.$elem.attr("src",b),c.options.tint&&(c.zoomTintImage.attr("src",a),c.zoomTintImage.attr("height",c.$elem.height()),c.zoomTintImage.css({height:c.$elem.height()}),c.zoomTint.css({height:c.$elem.height()})),c.zoomContainer.css("height",c.$elem.height()),c.zoomContainer.css("width",c.$elem.width());c.options.imageCrossfade&&
(c.zoomWrap.css("height",c.$elem.height()),c.zoomWrap.css("width",c.$elem.width()));c.options.constrainType&&("height"==c.options.constrainType&&(c.zoomContainer.css("height",c.options.constrainSize),c.zoomContainer.css("width","auto"),c.options.imageCrossfade?(c.zoomWrap.css("height",c.options.constrainSize),c.zoomWrap.css("width","auto"),c.constwidth=c.zoomWrap.width()):(c.$elem.css("height",c.options.constrainSize),c.$elem.css("width","auto"),c.constwidth=c.$elem.width()),"inner"==c.options.zoomType&&
(c.zoomWrap.parent().css("height",c.options.constrainSize),c.zoomWrap.parent().css("width",c.constwidth),c.zoomWindow.css("height",c.options.constrainSize),c.zoomWindow.css("width",c.constwidth)),c.options.tint&&(c.tintContainer.css("height",c.options.constrainSize),c.tintContainer.css("width",c.constwidth),c.zoomTint.css("height",c.options.constrainSize),c.zoomTint.css("width",c.constwidth),c.zoomTintImage.css("height",c.options.constrainSize),c.zoomTintImage.css("width",c.constwidth))),"width"==
c.options.constrainType&&(c.zoomContainer.css("height","auto"),c.zoomContainer.css("width",c.options.constrainSize),c.options.imageCrossfade?(c.zoomWrap.css("height","auto"),c.zoomWrap.css("width",c.options.constrainSize),c.constheight=c.zoomWrap.height()):(c.$elem.css("height","auto"),c.$elem.css("width",c.options.constrainSize),c.constheight=c.$elem.height()),"inner"==c.options.zoomType&&(c.zoomWrap.parent().css("height",c.constheight),c.zoomWrap.parent().css("width",c.options.constrainSize),c.zoomWindow.css("height",
c.constheight),c.zoomWindow.css("width",c.options.constrainSize)),c.options.tint&&(c.tintContainer.css("height",c.constheight),c.tintContainer.css("width",c.options.constrainSize),c.zoomTint.css("height",c.constheight),c.zoomTint.css("width",c.options.constrainSize),c.zoomTintImage.css("height",c.constheight),c.zoomTintImage.css("width",c.options.constrainSize))))},doneCallback:function(){this.options.loadingIcon&&this.spinner.hide();this.nzOffset=this.$elem.offset();this.nzWidth=this.$elem.width();
this.nzHeight=this.$elem.height();this.currentZoomLevel=this.options.zoomLevel;this.widthRatio=this.largeWidth/this.nzWidth;this.heightRatio=this.largeHeight/this.nzHeight;"window"==this.options.zoomType&&(lensHeight=this.nzHeight<this.options.zoomWindowWidth/this.widthRatio?this.nzHeight:String(this.options.zoomWindowHeight/this.heightRatio),lensWidth=this.options.zoomWindowWidth<this.options.zoomWindowWidth?this.nzWidth:this.options.zoomWindowWidth/this.widthRatio,this.zoomLens&&(this.zoomLens.css("width",
lensWidth),this.zoomLens.css("height",lensHeight)))},getCurrentImage:function(){return this.zoomImage},getGalleryList:function(){var b=this;b.gallerylist=[];b.options.gallery?d("#"+b.options.gallery+" a").each(function(){var a="";d(this).data("zoom-image")?a=d(this).data("zoom-image"):d(this).data("image")&&(a=d(this).data("image"));a==b.zoomImage?b.gallerylist.unshift({href:""+a+"",title:d(this).find("img").attr("title")}):b.gallerylist.push({href:""+a+"",title:d(this).find("img").attr("title")})}):
b.gallerylist.push({href:""+b.zoomImage+"",title:d(this).find("img").attr("title")});return b.gallerylist},changeZoomLevel:function(b){this.scrollingLock=!0;this.newvalue=parseFloat(b).toFixed(2);newvalue=parseFloat(b).toFixed(2);maxheightnewvalue=this.largeHeight/(this.options.zoomWindowHeight/this.nzHeight*this.nzHeight);maxwidthtnewvalue=this.largeWidth/(this.options.zoomWindowWidth/this.nzWidth*this.nzWidth);"inner"!=this.options.zoomType&&(maxheightnewvalue<=newvalue?(this.heightRatio=this.largeHeight/
maxheightnewvalue/this.nzHeight,this.newvalueheight=maxheightnewvalue,this.fullheight=!0):(this.heightRatio=this.largeHeight/newvalue/this.nzHeight,this.newvalueheight=newvalue,this.fullheight=!1),maxwidthtnewvalue<=newvalue?(this.widthRatio=this.largeWidth/maxwidthtnewvalue/this.nzWidth,this.newvaluewidth=maxwidthtnewvalue,this.fullwidth=!0):(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=newvalue,this.fullwidth=!1),"lens"==this.options.zoomType&&(maxheightnewvalue<=newvalue?
(this.fullwidth=!0,this.newvaluewidth=maxheightnewvalue):(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=newvalue,this.fullwidth=!1)));"inner"==this.options.zoomType&&(maxheightnewvalue=parseFloat(this.largeHeight/this.nzHeight).toFixed(2),maxwidthtnewvalue=parseFloat(this.largeWidth/this.nzWidth).toFixed(2),newvalue>maxheightnewvalue&&(newvalue=maxheightnewvalue),newvalue>maxwidthtnewvalue&&(newvalue=maxwidthtnewvalue),maxheightnewvalue<=newvalue?(this.heightRatio=this.largeHeight/
newvalue/this.nzHeight,this.newvalueheight=newvalue>maxheightnewvalue?maxheightnewvalue:newvalue,this.fullheight=!0):(this.heightRatio=this.largeHeight/newvalue/this.nzHeight,this.newvalueheight=newvalue>maxheightnewvalue?maxheightnewvalue:newvalue,this.fullheight=!1),maxwidthtnewvalue<=newvalue?(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=newvalue>maxwidthtnewvalue?maxwidthtnewvalue:newvalue,this.fullwidth=!0):(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=
newvalue,this.fullwidth=!1));scrcontinue=!1;"inner"==this.options.zoomType&&(this.nzWidth>this.nzHeight&&(this.newvaluewidth<=maxwidthtnewvalue?scrcontinue=!0:(scrcontinue=!1,this.fullwidth=this.fullheight=!0)),this.nzHeight>this.nzWidth&&(this.newvaluewidth<=maxwidthtnewvalue?scrcontinue=!0:(scrcontinue=!1,this.fullwidth=this.fullheight=!0)));"inner"!=this.options.zoomType&&(scrcontinue=!0);scrcontinue&&(this.zoomLock=0,this.changeZoom=!0,this.options.zoomWindowHeight/this.heightRatio<=this.nzHeight&&
(this.currentZoomLevel=this.newvalueheight,"lens"!=this.options.zoomType&&"inner"!=this.options.zoomType&&(this.changeBgSize=!0,this.zoomLens.css({height:String(this.options.zoomWindowHeight/this.heightRatio)+"px"})),"lens"==this.options.zoomType||"inner"==this.options.zoomType)&&(this.changeBgSize=!0),this.options.zoomWindowWidth/this.widthRatio<=this.nzWidth&&("inner"!=this.options.zoomType&&this.newvaluewidth>this.newvalueheight&&(this.currentZoomLevel=this.newvaluewidth),"lens"!=this.options.zoomType&&
"inner"!=this.options.zoomType&&(this.changeBgSize=!0,this.zoomLens.css({width:String(this.options.zoomWindowWidth/this.widthRatio)+"px"})),"lens"==this.options.zoomType||"inner"==this.options.zoomType)&&(this.changeBgSize=!0),"inner"==this.options.zoomType&&(this.changeBgSize=!0,this.nzWidth>this.nzHeight&&(this.currentZoomLevel=this.newvaluewidth),this.nzHeight>this.nzWidth&&(this.currentZoomLevel=this.newvaluewidth)));this.setPosition(this.currentLoc)},closeAll:function(){self.zoomWindow&&self.zoomWindow.hide();
self.zoomLens&&self.zoomLens.hide();self.zoomTint&&self.zoomTint.hide()},changeState:function(b){"enable"==b&&(this.options.zoomEnabled=!0);"disable"==b&&(this.options.zoomEnabled=!1)}};d.fn.elevateZoom=function(b){return this.each(function(){var a=Object.create(k);a.init(b,this);d.data(this,"elevateZoom",a)})};d.fn.elevateZoom.options={zoomActivation:"hover",zoomEnabled:!0,preloading:1,zoomLevel:1,scrollZoom:!1,scrollZoomIncrement:0.1,minZoomLevel:!1,maxZoomLevel:!1,easing:!1,easingAmount:12,lensSize:200,
zoomWindowWidth:400,zoomWindowHeight:400,zoomWindowOffetx:0,zoomWindowOffety:0,zoomWindowPosition:1,zoomWindowBgColour:"#fff",lensFadeIn:!1,lensFadeOut:!1,debug:!1,zoomWindowFadeIn:!1,zoomWindowFadeOut:!1,zoomWindowAlwaysShow:!1,zoomTintFadeIn:!1,zoomTintFadeOut:!1,borderSize:4,showLens:!0,borderColour:"#888",lensBorderSize:1,lensBorderColour:"#000",lensShape:"square",zoomType:"window",containLensZoom:!1,lensColour:"white",lensOpacity:0.4,lenszoom:!1,tint:!1,tintColour:"#333",tintOpacity:0.4,gallery:!1,
galleryActiveClass:"zoomGalleryActive",imageCrossfade:!1,constrainType:!1,constrainSize:!1,loadingIcon:!1,cursor:"default",responsive:!0,onComplete:d.noop,onZoomedImageLoaded:function(){},onImageSwap:d.noop,onImageSwapComplete:d.noop}})(jQuery,window,document);
}

// Promo global object
var P = {};    
(function($){
  $(document).ready(function(){
    var G = {};
    
    if($('#ProductJson-br-product-temp').length){
      window.pData = JSON.parse(document.getElementById('ProductJson-br-product-temp').innerHTML);
    }
    
    /* shared checkout cookie */
    if (getUrlVars()['sctest'] == 'true'){
      var in30Minutes = 1/48;
      Cookies.set('sctest', 'true', { expires: in30Minutes });
    }
    
    if(Cookies.get('sctest') == 'true'){
      $('#AddToCart-br-product-temp').click(function(e){
        e.preventDefault();
        var prodvar = $('#ProductID-br-product-temp').val();
        var prodsku = window.psku[prodvar];
        var qty = $('#qty-data').val();
        if(prodvar.length && qty > 0){
          location.href = 'https://checkout.gap.com.ph/search/?q='+prodsku+'&qty='+qty;
        }
      });
    }
    
    if(getUrlVars()['sctest'] == 'true' || Cookies.get('sctest') == 'true'){
      $('.sister-brands-inner a:not(.active)').click(function(e){
        e.preventDefault();
        var $this = $(this);
        location.href = $this.attr('href') + '?sctest=true';
      });
    }
    
    
    var $pop_row = $('#popular-row');
    $pop_row.slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      mobileFirst: false,
      nextArrow : '<button type="button" class="slick-next"></button>',
      prevArrow : '<button type="button" class="slick-prev"></button>',
      variableWidth: false,
      responsive: [
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]

    });
    
    // Datepicker Account Registration
    // $( "#dob" ).datepicker();
    
    // Brands Filter
    $(".letters-box a").click(function(e) {
        e.preventDefault();
        var filter = $(this).attr("class");   
 
        if(!$(this).hasClass("active")){
          $(".brands-letter").hide();
            if(filter == "letter-all") {
                $(".brands-letter").show();
                $(this).addClass('active').siblings().removeClass("active");
            } else {
                $(".letter-all").removeClass("active");
                $("."+$(this).attr("class")).show();
                $(this).addClass('active').siblings().removeClass("active");
            }
        }
    });
    
    
    // Hot Deals
    $("#sys_home_dock_hotdeal").on("click",function(){
      var $div = $("<div></div>").addClass("hotdeal-overlay");
      
      $("#sys_home_hotdeal_wrapper").toggleClass("active")
      if($("#sys_home_hotdeal_wrapper").hasClass("active"))
        $div.appendTo($("body"));
      else
        $(".hotdeal-overlay").remove();  
      $("#sys_home_hotdeal_wrapper").stop().slideToggle();
    });
    
    // Moble Menu
    if($(window).width() < 959) {
      $(".nav-toggle").on("click",function(){       
          if ($('html').hasClass('nav-open')) {
              $('html').removeClass('nav-open');
              setTimeout(function () {
                  $('html').removeClass('nav-before-open');
              }, 300);
          } else {
              $('html').addClass('nav-before-open');
              setTimeout(function () {
                  $('html').addClass('nav-open');
              }, 42);
          }
       });
    
      $(".menu > ul > li").unbind("click");
        $(".menu > ul > li").click(function () {
            if ($(window).width() <= 943) {
                if($(this).hasClass('active')){
                    $(this).removeClass('active');
                    $(this).children(".content-level-0").slideUp(150);
                }else {
                    $(".menu > ul > li").removeClass('active');
                    $(this).addClass('active');
                    $(".menu > ul > li .content-level-0").slideUp(150);
                    $(this).children(".content-level-0").slideDown(150);
                }
            }
        });
    }
    
    
    $("#promo-banner-details .dialogify").on("click",function(){
      $(".modal-popup").addClass("_show");
      if($(".modals-overlay").length == 0)
        $("<div></div>").addClass("modals-overlay").appendTo($(".modals-wrapper"));
    });

    $(".modal-popup .action-close").on("click",function(){
      $(".modal-popup").removeClass("_show");
      $(".modals-overlay").remove();
    });


    $('.prod-image-section .image-display .display-lists li img').click(function(e){
//       e.preventDefault();
        var $this = $(this)

        if($this.hasClass('zoomed')){
          $this.removeClass('zoomed')
          $('.zoomContainer').remove()
          
        } else{
          $this.addClass('zoomed')
          $this.elevateZoom({
            zoomWindowFadeIn: 300,
            zoomWindowFadeOut: 300,
            lensFadeIn: 300,
            lensFadeOut: 300,
            loadingIcon: 'http://www.elevateweb.co.uk/spinner.gif'        
          })
        }
    })

//     $(".image-main.cycle-slide-active").elevateZoom({
//       gallery:'cycle-slideshow', 
//       cursor: 'pointer', 
//       galleryActiveClass: 'cycle-pager-active',      
//       zoomWindowFadeIn: 300,
//       zoomWindowFadeOut: 300,
//       lensFadeIn: 300,
//       lensFadeOut: 300,
//       loadingIcon: 'http://www.elevateweb.co.uk/spinner.gif'
//     });
    
//     $("#img-pager>div").click(function(){
//       $(".image-main.cycle-slide-active").elevateZoom({
//         gallery:'cycle-slideshow', 
//         cursor: 'pointer', 
//         galleryActiveClass: 'cycle-pager-active',      
//         zoomWindowFadeIn: 300,
//         zoomWindowFadeOut: 300,
//         lensFadeIn: 300,
//         lensFadeOut: 300,
//         loadingIcon: 'http://www.elevateweb.co.uk/spinner.gif'
//       });    
//     })
    
//      var ezAPI = $(".image-main.cycle-slide-active").data('elevateZoom');
//      var mq = window.matchMedia('(min-width: 768px)');
//       mq.addListener((b) => {
//         if (b.matches) {
//             // do something for screens > 768px, for example turn on zoom
//             ezAPI.changeState('enable');
//         } else {
//             // do something for screens < 768px, for example turn off zoom
//             ezAPI.changeState('disable');
//           	$('.zoomContainer').remove();
//         }
//       });

    var $pop_product_carousel = $('#popular-product-carousel')
    $pop_product_carousel.slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      mobileFirst: false,
      nextArrow : '<button type="button" class="slick-next"></button>',
      prevArrow : '<button type="button" class="slick-prev"></button>',
      variableWidth: false,
      responsive: [
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    var _init = function () {
      var $widget = this,
          $colorswatch = $('.color .swatch-option'),
          $element = $('.swatch-option-tooltip'),
          timer,
          type = parseInt($colorswatch.attr('option-type'), 10),
          label = $colorswatch.attr('option-label'),
          thumb = $colorswatch.attr('option-tooltip-thumb'),
          value = $colorswatch.attr('option-tooltip-value'),
          $image,
          $title,
          $corner;

      if (!$element.size()) {
        $element = $('<div class="swatch-option-tooltip"><div class="image"></div><div class="title"></div><div class="corner"></div></div>');
        $('body').append($element);
      }

      $image = $element.find('.image');
      $title = $element.find('.title');
      $corner = $element.find('.corner');

      $colorswatch.hover(function () {
        if (!$colorswatch.hasClass('disabled')) {
          timer = setTimeout(
            function () {
              var leftOpt = null,
                  leftCorner = 0,
                  left,
                  $window;
              $image.css({
                'background': 'url("' + thumb + '") no-repeat center', //Background case
                'background-size': 'initial'
              });
              $image.show();
              $title.text(label);
              leftOpt = $colorswatch.offset().left;
              left = leftOpt + $colorswatch.width() / 2 - $element.width() / 2;
              $window = $(window);

              // the numbers (5 and 5) is magick constants for offset from left or right page
              if (left < 0) {
                left = 5;
              } else if (left + $element.width() > $window.width()) {
                left = $window.width() - $element.width() - 5;
              }

              // the numbers (6,  3 and 18) is magick constants for offset tooltip
              leftCorner = 0;

              if ($element.width() < $colorswatch.width()) {
                leftCorner = $element.width() / 2 - 3;
              } else {
                leftCorner = (leftOpt > left ? leftOpt - left : left - leftOpt) + $colorswatch.width() / 2 - 6;
              }

              $corner.css({
                left: leftCorner
              });
              $element.css({
                left: left,
                top: $colorswatch.offset().top - $element.height() - $corner.height() - 18
              }).show();
            },
            200
          );
        }
      }, function () {
        $element.hide();
        clearTimeout(timer);
      });

      $(document).on('tap', function () {
        $element.hide();
        clearTimeout(timer);
      });

      $colorswatch.on('tap', function (event) {
        event.stopPropagation();
      });
    }
    
    if($('body').hasClass('template-product')){
      // color / variant switching
      // window.pData -> global object for product data
      window.pVars = window.pData.variants;
      var $addToCartBtn = $('#AddToCart-br-product-temp'),
          $productFormID = $('#ProductID-br-product-temp'),
          varslength = window.pVars.length;   

      function getStockText(varid){
        var invCount = window.viq[varid],
            stockText = (invCount > 1) ? ' stocks left' : ' stock left';
        if(invCount == 0){
          stockText = "Out of stock";
        } else {
          stockText = 'Only ' + invCount + stockText;
        }
        $('#variant-inventory').text(stockText);

        var qtyData = $('#qty-button').data("currqty");
        $('#qty-button').data("currqty", invCount)         
      }

      function getVarID(opts){
        if(opts.prodtype == "Shoes"){
          // logic for shoes
          var optcolor = opts.color,
              optsize = opts.size;
          for (var a = 0; a < varslength; a++){
            var currVar = window.pVars[a],
                currColor = currVar.option1,
                currSize = currVar.option2
            if(currColor == optcolor && currSize == optsize){
              $productFormID.val(currVar.id);
              getStockText(currVar.id);
            }
          }
        }
      }
      
      function getVarID2(obj){
          for(var a = 0; a < varslength; a++){
            var currVar = window.pVars[a]
            var $len = obj.len,
                $color = obj.color,
                $size = obj.size
                
              if($len != null ){
                  if(currVar.option1 == $color && currVar.option2 == $size && currVar.option3 == $len){
                      $productFormID.val(currVar.id);
                        getStockText(currVar.id)
                  }
              } else {
                  if(currVar.option1 == $color && currVar.option2 == $size){
                      $productFormID.val(currVar.id);
                       getStockText(currVar.id)
                  }
              }
          }
      }      

      function updateVarPrice(opts){
        var optid = opts.id;
        for (var a = 0; a < varslength; a++){
          var moneySymbol = "₱";
          var currVar = window.pVars[a],
              salePrice = currVar.price,
              origPrice = currVar.compare_at_price,
              $regPriceSpan = $('#ComparePrice-br-product-temp'),
              $salePriceSpan = $('#ProductPrice-br-product-temp'),
              currPrice = currVar.price/100,
              currPrice = currPrice.toFixed(2),
              currPrice = moneySymbol + currPrice.toLocaleString(),
              regPrice = currVar.compare_at_price/100,
              regPrice = regPrice.toFixed(2),
              regPrice = moneySymbol + regPrice.toLocaleString();
          if(currVar.id == optid){
            if(salePrice < origPrice){
              $regPriceSpan.text(regPrice).parent().show();
              $salePriceSpan.closest('.prod-price').addClass('sale')
              $salePriceSpan.text(currPrice);
              $salePriceSpan.siblings().show()
            } else {
              $regPriceSpan.parent().hide();
              $salePriceSpan.closest('.prod-price').removeClass('sale')
              $salePriceSpan.text(currPrice);
              $salePriceSpan.siblings().hide()
            }
          }
        }
      }

// $('.color .swatch-option').click(function(e){
// 	var $this = $(this),
// 		color = $this.attr('option-label');
    
// });
      
      
      $(".quantity-select .input-qty.selection").click(function(){
          var $this = $(this),
              $qtydata = $this.children().data('qval'),
              $parent = $this.parent(),
              $inputData = $('#qty-data'),
              $qtyBtn = $("#qty-button")
          var $curqty = $('#qty-button').data("currqty");

              if($qtydata > $curqty){
                  var lowestQty = ".input."+$curqty.toString()
                  // $this.parent().find(lowestQty).trigger('click')
                  $qtyBtn.children().text($curqty)
                  $inputData.val($curqty)
                  $('#oos-qty').show();
              } else {
                  $qtyBtn.children().text($qtydata)
                  $inputData.val($qtydata)
                  $('#oos-qty').hide();
              }
              $parent.toggle("slide").toggleClass('active')
      })      
      

      $('.image-carousel .image-lists li').click(function(e){
          e.preventDefault();
          var $this = $(this),
              idx = $this.index();
          $this.addClass('active').siblings().removeClass('active');
          $('.image-display .display-lists li').hide();
          $('.image-display .display-lists li:eq('+idx+')').show();
      });

$('.color .swatch-option').click(function(e) {
  var $this = $(this);
  console.log('Color swatch clicked:', $this.attr('option-label'));
  
   if (!$this.hasClass('disabled')){
    $('#oos-colsiz').hide();
    
    var $idx = $this.data('swatch-index'),
        $label = $this.attr('option-label');
    
    console.log('Selected color label:', $label);
    
    // Get base handle without color and update URL
    var currentPath = window.location.pathname;
    var pathParts = currentPath.split('/');
    var currentHandle = pathParts[pathParts.length - 1];

    console.log('Current path:', currentPath);
    console.log('Current handle:', currentHandle);

    // Extract just the base product handle without any color suffix
    var baseProductMatch = currentHandle.match(/(.*?-\d+)/);
    var baseProductHandle = baseProductMatch ? baseProductMatch[1] : currentHandle;

    console.log('Base product match:', baseProductMatch);
    console.log('Base product handle:', baseProductHandle);

    // Create new URL with base handle and new color
    var newHandle = baseProductHandle + '-' + $label.toLowerCase().replace(/\s+/g, '-');
    var newUrl = '/products/' + newHandle;

    console.log('New handle:', newHandle);
    console.log('New URL:', newUrl);

    $this.addClass('selected').siblings().removeClass('selected');
    
    
    // change showcased image group according to color selected
    var $imgGroupMain = $('.img-group:eq('+$idx+').container-zoom').show(),
        $imgGroupPager = $('.img-group.container-pager:eq('+$idx+')').show();

    $('.image-carousel li').hide();
    $('.image-carousel img[alt="'+$label+'"]').closest('li').show().first().trigger('click');
    
    $imgGroupMain.children().first().trigger('click');
    $imgGroupPager.children().first().trigger('click');
    $imgGroupMain.siblings('.container-zoom').hide();
    $imgGroupPager.siblings('.container-pager').hide();
    // show the selected color on label
    $this.parent().prev().find('.swatch-attribute-selected-option').text($label);

    // disable all sizes first
    $('.size .swatch-option, .width .swatch-option, .waist .swatch-option').addClass('disabled');
    
    if($('#swatch-container-wrap').data('options').indexOf('size')){
      for (var a = 0; a < varslength; a++){
        var currVar = window.pVars[a],
            currColor = currVar.option1,
            currSize = currVar.option2,
            currWidth = currVar.option3,                  
            qtyCount = window.viq[currVar.id],
            $size = $('.size .swatch-option[option-label="'+currSize+'"]'),
            $waist = $('.waist .swatch-option[option-label="'+currSize+'"]'),
            $width = $('.width .swatch-option[option-label="'+currWidth+'"]');                  

        var opts = {
          id: currVar.id
        }

        if(currColor == $label){
          $productFormID.val(currVar.id);
          $addToCartBtn.removeClass('disabled').attr('disabled',false);

          // Update URL with variant ID
          window.history.replaceState({}, '', newUrl + '?variant=' + currVar.id);

          if(currVar.available) {
            $size.removeClass('disabled').addClass('available').children('input').attr('disabled',false);
            $waist.removeClass('disabled').addClass('available').children('input').attr('disabled',false);
            $width.removeClass('disabled').addClass('available').children('input').attr('disabled',false);
            if(qtyCount > 0){
              updateVarPrice(opts);
            }
          }
          if(window.viq[currVar.id] != undefined){
            getStockText(currVar.id);
          }
        }
      }
    } else {
      var colorSizeOptions = [];
      var activeSwatch = $('.size .swatch-option.selected'),
          activeSize = activeSwatch.attr('option-label'),
          activeWidthSwatch = $('.width .swatch-option.selected'),
          activeWidth = activeWidthSwatch.attr('option-label');
      
      activeSwatch.removeClass('selected');
      activeWidthSwatch.removeClass('selected');
      $('.size .swatch-attribute-selected-option').text('');
      $productFormID.val('');
      $addToCartBtn.addClass('disabled').attr('disabled',true);
      $addToCartBtn.find('.cart-button').addClass('disabled').attr('disabled',true); 
      
      for (var a = 0; a < varslength; a++){
        var currVar = window.pVars[a],
            currColor = currVar.option1,
            currSize = currVar.option2,
            currWidth = currVar.option3;
        if(currColor == $label){
          colorSizeOptions.push(currSize);
          var $size = $('.size .swatch-option[option-label="'+currSize+'"]');
          var $waist = $('.waist .swatch-option[option-label="'+currSize+'"]');
          var $width = $('.width .swatch-option[option-label="'+currWidth+'"]');
          
          // Update URL with variant ID for first available variant of this color
          if(currVar.available && !window.history.state) {
            window.history.replaceState({}, '', newUrl + '?variant=' + currVar.id);
          }
          
          if(currVar.available) {
            $size.removeClass('disabled').addClass('available').children('input').attr('disabled',false);
            $waist.removeClass('disabled').addClass('available').children('input').attr('disabled',false);
            $width.removeClass('disabled').addClass('available').children('input').attr('disabled',false);
            if(activeSize == currSize){
              getStockText(currVar.id);
              activeSwatch.addClass('selected');
              var opts = {
                id: currVar.id
              }
              updateVarPrice(opts);   
              $productFormID.val(currVar.id);
              $addToCartBtn.addClass('enabled').attr('enabled',true);                    
            }
          } else {
            if(activeSize == currSize){
              $('.size .swatch-attribute-selected-option').text('');
              $productFormID.val('');
              $addToCartBtn.addClass('disabled').attr('disabled',true);
              $addToCartBtn.find('.cart-button').addClass('disabled').attr('disabled',true);
            }
            $size.addClass('disabled').removeClass('selected')
            .removeClass('available').children('input')
            .attr('disabled',true);
          }
        }
      }

      // check if a size is already selected
      var selectedVarID = $('#ProductID-br-product-temp').val();
      if ($('.size .swatch-option.selected').length && selectedVarID != ""){
        $addToCartBtn.removeClass('disabled').attr('disabled',false);
        var opts = {
          id: selectedVarID
        }
        updateVarPrice(opts);
      }            
    }
  } else {
    $('#oos-colsiz').show();
    $addToCartBtn.addClass('disabled').attr('disabled',true);
    $addToCartBtn.find('.cart-button').addClass('disabled').attr('disabled',true); 
    return false;
  }
});
      
      
      function findAvailableLengths(width){ 
        for (var a = 0; a < varslength; a++){
          var currVar = window.pVars[a],
              currColor = currVar.option1,
              currSize = currVar.option2,
              currWidth = currVar.option3

          if(currColor == width.color && currSize == width.waist && currVar.available){ 
            
            var $width = $('.width .swatch-option[option-label="'+currWidth+'"]');
            $width.removeClass('disabled').addClass('available').children('input').attr('disabled',false);
          }
        }
      }
      
      
      
//       $('.size .swatch-option, .bottom_width .swatch-option, .waist .swatch-option').click(function(e) {
// //         console.log("Click worked")
//             console.log(" This is the past ID = " + $productFormID.val())
//           var $this = $(this),
//               productType = $('#productTypeContainer').val(),
//               option2name = $('#option2name').val(),
//               option3name = $('#option3name').val(),
//               swatchType = $('.swatch-top'),
//               selectedColor = swatchType.find('.swatch-option.clr.selected').attr('option-label'),
//               selectedSize = (swatchType.hasClass('waist')) ? swatchType.find('.swatch-option.wst.selected').attr('option-label') : swatchType.find('.swatch-option.sz.selected').attr('option-label'); // waist kapag meron
//           var selectedLength = swatchType.find('.swatch-option.wdth.selected').attr('option-label'); // len kasi reserved word yung length
 
        
        
//         if (!$this.hasClass('disabled')){    
//           $('#oos-colsiz').hide();
              
              
//           var $idx = $this.index();
//           var $label = $this.attr('option-label')
//           $(this).addClass('selected').siblings().removeClass('selected');    
//           $this.closest('.swatch-top').find('.swatch-attribute-selected-option').text($label); // changed by Rengie 12/Feb/2019
//           var $swatchAttribute = $this.closest('.swatch-attribute');


//           if(swatchType.hasClass('waist')){
//             selectedSize = swatchType.find('.swatch-option.wst.selected').attr('option-label');
//           } else{
//             selectedSize = swatchType.find('.swatch-option.sz.selected').attr('option-label');
//           }
          
//           if(swatchType.hasClass('color')){
//             selectedColor = swatchType.find('.swatch-option.clr.selected').attr('option-label')
//           }
          
//           if(swatchType.hasClass('width')){
//             selectedLength = (swatchType.find('.swatch-option.wdth').hasClass('selected')) ? swatchType.find('.swatch-option.wdth.selected').attr('option-label') : null;
//           }          


// //           console.log(selectedColor + " ")
// //           console.log(selectedSize + " ")
// //           console.log(selectedLength + " ")
          
//           var objForVar = {
//             color: selectedColor,
//             size: selectedSize, // aka waist
//             len: selectedLength
//           }

//           getVarID2(objForVar); 
//           objForVar.id = $productFormID.val();
          
//           var waisted = (option2name.indexOf('Waist') > -1);
//           if(waisted){
//               var waistData = {
//                   color: selectedColor,
//                   waist: selectedSize
//               }
//               findAvailableLengths(waistData)  
              
//             if(selectedSize != null && selectedLength != null){
//               $addToCartBtn.removeClass('disabled').attr('disabled',false);
//               $addToCartBtn.children().removeClass('disabled').attr('disabled',false);    
              
//             } else{
//               $addToCartBtn.addClass('disabled').attr('disabled',true);
//               $addToCartBtn.children().addClass('disabled').attr('disabled',true);            
//             }
//           } else{
//             console.log(" NOT JEANS IN")
//             if(selectedColor != null || selectedSize != ''){
//               $addToCartBtn.removeClass('disabled').attr('disabled',false);
//               $addToCartBtn.children().removeClass('disabled').attr('disabled',false);
//             }           
//           }
          
// //           if($swatchAttribute.hasClass('size')){
// //             var opts = {
// //               prodtype: "Shoes",
// //               color: $('.color .swatch-option.selected').attr('option-label'),
// //               size: $label
// //             }
// //             getVarID(opts);
// //             opts.id = $productFormID.val();
            
// // //             console.log($productFormID.val() + " Sizes on click test")
            
// //             updateVarPrice(opts);
// //             $addToCartBtn.removeClass('disabled').attr('disabled',false);
// //             for(v in window.viq){
// //               if(window.viq[opts.id] != undefined){
// //                 getStockText(opts.id);
// //               }
// //             }
// //           } else {
// //             if($('.color .swatch-option.selected').length && $('.size .swatch-option.selected').length){
// //               $addToCartBtn.removeClass('disabled').attr('disabled',false);
// //             }
// //           }

//         } else {
//           $('#oos-colsiz').show();  
//           $addToCartBtn.addClass('disabled').attr('disabled',true);
//           $addToCartBtn.find('.cart-button').addClass('disabled').attr('disabled',true);           
//         }
//       });
      
      function getSameProduct(maintitle, styleNumber) {
        const title  = maintitle,
              search_url = `https://${window.location.hostname}/search?view=json&q="${encodeURIComponent(title)}"`,
              results = null;
        $.ajax({
          url: search_url,
          method: "GET",
          success: function(data) {
            var data = JSON.parse(data),
                dresults = data.results.filter(result => result.title === title && parseInt(result.style_number) === parseInt(styleNumber));

                
            buildColorSelection(dresults)
          },
          error: function(error) {
            console.log(error)
          }
        });

      }
      

      var selectedColor = $('#curr_color').data('current-color'),
          prodTitle = $('h1.prod-title').text().trim();
      
      
      if (prodTitle.indexOf(selectedColor) >= 0) {
        prodTitle = prodTitle.replace(selectedColor, '');
      }
      
      var handleWithoutColor = currentProduct.handle.replace(`-${currentProduct.color_handleize}`, ''),
          lastIndex = handleWithoutColor.length - 7,
          removeNotNumber = handleWithoutColor.replace(handleWithoutColor.substring(0, lastIndex + 1)),
          styleNumber = removeNotNumber.includes('undefined') ? removeNotNumber.replace('undefined', '') : removeNotNumber;

      var similarTitle = currentProduct.title || prodTitle,
          similarNumber = currentProduct.style_number || styleNumber;

      getSameProduct(similarTitle, similarNumber)


      function buildColorSelection(items) {
        var theme = window.theme || {},
            colorsTpl = '',
            currentColor = $('#curr_color').data('current-color');
        
            

        theme.similarItems = items;
        
        var uColor = []

        items.map(item => {
          
          if(!uColor.includes(item.color)) {
          
            var template = swatchTpl

            template = template.replace(/{{selected}}/g, item.color === currentColor ? 'selected' : '');
            template = template.replace(/{{colorValue}}/g, item.color);
            template = template.replace(/{{valuethumb}}/g, item.swatch);
            template = template.replace(/{{available}}/g, item.available ? 'available' : 'disabled');

            colorsTpl += template
            uColor.push(item.color)
          }
        })

        $('.swatch-option .color-container').html(colorsTpl);

      }
      
   $(document).on('click', '.cta-section .swatch-option.color .swatch-btn', function() {
  var $this = $(this),
      newColor = $this.find('input').val(),
      currentUrl = window.location.pathname,
      urlParts = currentUrl.split('/'),
      currentHandle = urlParts[urlParts.length - 1].split('?')[0], // Get handle without query params
      // Extract base handle using regex to match up to the number
      baseProductMatch = currentHandle.match(/(.*?-\d+)/),
      baseHandle = baseProductMatch ? baseProductMatch[1] : currentHandle,
      newHandle = baseHandle + '-' + newColor.toLowerCase().replace(/\s+/g, '-');

  // Preserve any existing query parameters
  var searchParams = new URLSearchParams(window.location.search);
  
  // Navigate to new URL
  window.location.href = '/products/' + newHandle + (searchParams.toString() ? '?' + searchParams.toString() : '');
});
      

    $(document).on('click', '.swatch-option.color .swatch-btn', function(e) {
      e.preventDefault();
      var $this = $(this);
      var selectedColor = $this.data('value');
      var productHandle = 'shell-tank-768715-' + selectedColor.toLowerCase().replace(/ /g, '-');
      
      // Redirect to the correct product URL for this color
      window.location.href = '/products/' + productHandle;
    });
    
    $(document).on('click', '.cta-section .swatch-option:not(.color) .swatch-btn', function() {
      var $this = $(this),
          color = $this.closest('.cta-section').find('.swatch-btn.clr.selected').find('input').val(),
          size = $this.find('input').val(),
          length = $this.closest('.cta-section').find('.swatch-option.width'),
          value = $this.find('input').val(),
          product = theme.similarItems.filter(item => item.color === color)[0],
          label = $this.closest('.size-container').siblings('.swatch-label-size').find('.selected-input'),
          cartBtn = $('#AddToCart-br-product-temp button');
      var selectedValues = [];
    
      // Update selection state regardless of availability
      $this.addClass('selected').siblings().removeClass('selected');
      label.text(value);
    
      // Show/hide OOS message based on availability
      if($this.hasClass('disabled')) {
        $('#oos-colsiz').css('display', 'flex');
        cartBtn.addClass('disabled').attr('disabled', true);
      } else {
        $('#oos-colsiz').css('display', 'none');
        cartBtn.removeClass('disabled').removeAttr('disabled');
      }
    
      $('.br-swatch-option[data-option-index]').each((i, option) => {
        var $this = $(option),
            index = $this.data('option-index'),
            value = $this.find('.swatch-btn.selected input').val();
    
        selectedValues.push({
          value: value || null,
          index: parseInt(index)
        });
      });
    
      var selectedVariant = product.variants.find(function(variant) {
        return selectedValues.every(function(values) {
          return variant.title.split(' / ')[values.index] === values.value;
        });
      }) || null;
    
      if(selectedVariant) {
        // Update URL with just the variant parameter
        var currentUrl = window.location.pathname;
        var newUrl = currentUrl + '?variant=' + selectedVariant.id;
        window.history.replaceState({}, '', newUrl);
        
        updateVariantId(selectedVariant);
        
        if($('.br-swatch-option[data-option-index]').length === selectedValues.length && !$this.hasClass('disabled')) {
          cartBtn.removeClass('disabled').removeAttr('disabled');
        }
      }
    });

      
      Array.prototype.diff = function(arr2) {
        var ret = [];
        this.sort();
        arr2.sort();
        for(var i = 0; i < this.length; i += 1) {
          if(arr2.indexOf(this[i]) > -1){
            ret.push(this[i]);
          }
        }
        return ret;
      };
      
      $(document).on('click', '.prod-image-section .image-lists li', function() {
        var $this = $(this),
            index = $this.index(),
            mainImg = $('.prod-image-section .display-lists li');
        
        $this.addClass('active').siblings().removeClass('active')
        mainImg.eq(index).addClass('active').siblings().removeClass('active')
      })

      
      $('.prod-image-section .mobile-display .img-lists .mob-img-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      });
      
      function replaceImages(images) {
        var featured_image = images[0],
            htmlTpl = '';
        
        images.map(image => {
          htmlTpl += `<li class="{{active}}">
                        <a href="javascript:void(0)">
                            <img src="{{src}}" alt="{{alt}}">
                          </a>
                        </li>`
          
          
          htmlTpl = htmlTpl.replace(/{{active}}/g, image === featured_image ? 'active' : '');
          htmlTpl = htmlTpl.replace(/{{src}}/g, image.src);
          htmlTpl = htmlTpl.replace(/{{alt}}/g, image.alt);
          
        })
        
//         if($('.prod-image-section .image-lists, .prod-image-section .mobile-display .img-lists').hasClass('slick-initialized')) {
//           $('.prod-image-section .image-lists, .prod-image-section .mobile-display .img-lists').empty()
//         }
        
        $('.prod-image-section .image-lists, .prod-image-section .display-lists').html(htmlTpl);
//         $('.prod-image-section .image-lists, .prod-image-section .mobile-display .img-lists').html(htmlTpl);
        
        var mobItem = $('.prod-image-section .mobile-display .img-lists .mob-img-slider li')
        
        
        var mobEl = $('.prod-image-section .mobile-display .img-lists .mob-img-slider')

        if(mobEl.hasClass('slick-initialized')) {
          mobEl.slick('unslick');
          mobEl.empty()
          mobEl.html(htmlTpl)
        }

        var mobSlider = mobEl.slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        });
        
        // console.log(mobItem.length)
        // console.log(images.length)
      }
      
      function buildVariantOptions(product) {
        var options = product.options_with_values,
            colorIndex = options.findIndex(option => option.name === 'Color'),
            sizeIndex = options.findIndex(option => option.name === 'Size'),
            waistIndex = options.findIndex(option => option.name === 'Waist'),
            lengthIndex = options.findIndex(option => option.name === 'Length'),
            variants = product.variants,
            currentColor = product.color,
            sizeTpl = '',
            waistTpl = '',
            lengthTpl = '',
            uSizes = [],
            uWaist = [],
            uLengths =[];
        
        options.map(option => {
          if(option.name === 'Size') {
            variants.map(variant => {
              var sizeVal = variant.title.split(' / ')[sizeIndex]
              var is_available = variants.filter(variant => variant.title.split(' / ')[sizeIndex] === sizeVal && variant.available).length > 0;
              if(!uSizes.includes(sizeVal)) {
                sizeTpl += `<li class="swatch-btn swatch-option sz ${is_available ? 'available' : 'disabled'} ${sizeVal}" data-swatch-index="1" data-value="${sizeVal}" option-label="${sizeVal}">
                                <span style="justify-content: center; display: flex; height: 100%; align-items: center;">
                                    <span>${sizeVal}</span>
                                </span>
                                <input type="radio" id="swatch-1-${sizeVal}" name="option-1" value="${sizeVal}">
                              </li>`
              }
              uSizes.push(sizeVal)
            })
          }else if(option.name === 'Waist') {
            variants.map(variant => {
              var waistVal = variant.title.split(' / ')[waistIndex]
              var is_available = variants.filter(variant => variant.title.split(' / ')[waistIndex] === waistVal && variant.available).length > 0;
              if(!uWaist.includes(waistVal)) {
                  waistTpl += `<li class="swatch-btn swatch-option wst ${is_available ? 'available' : 'disabled'} ${waistVal}" data-swatch-index="1" data-value="${waistVal}" option-label="${waistVal}"><span style="justify-content: center; display: flex; height: 100%; align-items: center;"><span>${waistVal}</span></span>

                              <input type="radio" id="swatch-1-${waistVal}" name="option-1" value="${waistVal}">
                        </li>`
               }
              uWaist.push(waistVal)
            })
          }else if(option.name === 'Length') {
              variants.map(variant => {
                var lengthVal = variant.title.split(' / ')[lengthIndex]
                var is_available = variants.filter(variant => variant.title.split(' / ')[lengthIndex] === lengthVal && variant.available).length > 0;
                if(!uLengths.includes(lengthVal)) {
                  lengthTpl += `<li class="swatch-btn swatch-option wdth swatch-element swatch-option text ${lengthVal} ${is_available ? 'available' : 'disabled'}" data-swatch-index="8" data-value="${lengthVal}" option-label="${lengthVal}"><span style="justify-content: center; display: flex; height: 100%; align-items: center;"><span>${lengthVal}</span></span>

                        <input type="radio" id="swatch-2-${lengthVal}" name="option-2" value="${lengthVal}">
                    </li>`
                }
                uLengths.push(lengthVal)
              })
          }
        })
        
          $('.size-container .size-list.size').html(sizeTpl)
          $('.size-container .size-list.waist').html(waistTpl)
          $('.size-container .size-list.length').html(lengthTpl)
          $('.swatch-label-color .selected-input').text(product.color)
          
          
      }
      
      function updateVariantId(variant) {
        var sectionId = $('#pr-section-id').val(),
            inputId = $(`#ProductID-${sectionId}`);
        inputId.val(variant.id).change();
      }
      
      function updatePrice(variant) {
        var regularTpl = `<h5 class="price-highlight">
                        <span id="ProductPrice-br-product-temp">${theme.Currency.formatMoney(variant.price, theme.moneyFormat)}</span>
                      </h5>`,
            saleTpl = `<h5 class="price-highlight">
                        <span id="ProductPrice-br-product-temp">${theme.Currency.formatMoney(variant.price, theme.moneyFormat)}</span>
                      </h5>
                      <h5 class="markdown"><span id="ComparePrice-br-product-temp">${theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)}</span></h5>
                    `,
            priceContainer = $('.prod-order-section .prod-titleprice .prod-ec-details .prod-price')
        
                      
        
        if(variant.compare_at_price > variant.price) {
          priceContainer.html(saleTpl)
          priceContainer.addClass('sale')
        }else {
          priceContainer.html(regularTpl)
          priceContainer.removeClass('sale')
        }
      }
      
     function updateUrl(product, variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        // Create URL object from current location
        let url = new URL(window.location.href);
        
        // Update or add variant parameter
        url.searchParams.set('variant', variant.id);

        // Replace current URL state while preserving other parameters
        history.replaceState({}, '', url.toString());

        // Track product view if tracking object exists
        if(track_obj) {
          view_product(track_obj)
        }
      }

    }
    
    
    var swatchtooltip = function (item){ 
      var $element = $('.swatch-option-tooltip'),
          timer,
          $image,
          $title,
          $corner;

      if (!$element.size()) {
        $element = $('<div class="swatch-option-tooltip"><div class="image"></div><div class="title"></div><div class="corner"></div></div>');
        $('body').append($element);
      }

      $image = $element.find('.image');
      $title = $element.find('.title');
      $corner = $element.find('.corner');

//       item.hover(function () {
//         var $this = $(this),
//             label = $this.attr('option-label'),
//             thumb = $this.attr('option-tooltip-thumb'),
//             value = $this.attr('option-tooltip-value'),
//             type = parseInt($this.attr('option-type'), 10);
//         if (!$this.hasClass('disabled')) {
//           timer = setTimeout(
//             function () {
//               var leftOpt = null,
//                   leftCorner = 0,
//                   left,
//                   $window;
//               if (type === 2) {
//                 // Image
//                 $image.css({
//                   'background': 'url("' + thumb + '") no-repeat center', //Background case
//                   'background-size': 'initial'
//                 });
//                 $image.show();
//               } else if (type === 1) {
//                 // Color
//                 $image.css({
//                   background: value
//                 });
//                 $image.show();
//               } else if (type === 0 || type === 3) {
//                 // Default
//                 $image.hide();
//               }
//               $title.text(label);
//               leftOpt = $this.offset().left;
//               left = leftOpt + $this.width() / 2 - $element.width() / 2;
//               $window = $(window);
//               // the numbers (5 and 5) is magick constants for offset from left or right page
//               if (left < 0) {
//                 left = 5;
//               } else if (left + $element.width() > $window.width()) {
//                 left = $window.width() - $element.width() - 5;
//               }

//               // the numbers (6,  3 and 18) is magick constants for offset tooltip
//               leftCorner = 0;

//               if ($element.width() < $this.width()) {
//                 leftCorner = $element.width() / 2 - 3;
//               } else {
//                 leftCorner = (leftOpt > left ? leftOpt - left : left - leftOpt) + $this.width() / 2 - 6;
//               }

//               $corner.css({
//                 left: leftCorner
//               });
//               $element.css({
//                 left: left,
//                 top: $this.offset().top - $element.height() - $corner.height() - 18
//               }).show();
//             },
//             200
//           );
//         }
//       }, function () {
//         $element.hide();
//         clearTimeout(timer);
//       });

      $(document).on('tap', function () {
        $element.hide();
        clearTimeout(timer);
      });
    }
    
    $('#bc-sf-filter-products').on('click','.swatch-option.image',function(e){
      var $this = $(this),
          idx = $this.index(),
          $parent = $this.closest('.product-item'),
          $imgContainer = $parent.find('.img-container');
      $imgContainer.children('img').eq(idx).show().siblings().hide();
      
      
    });
    
    
    
    var filswatchtooltip = function (item){ 
      var $element = $('.swatch-option-tooltip'),
          timer,
          $image,
          $title,
          $corner;

      if (!$element.size()) {
        $element = $('<div class="swatch-option-tooltip"><div class="image"></div><div class="title"></div><div class="corner"></div></div>');
        $('body').append($element);
      }
      $image = $element.find('.image');
      $title = $element.find('.title');
      $corner = $element.find('.corner');
      item.hover(function () {
        var $this = $(this),
            label = $this.parent().data('title'),
            type = 2;

        var texts = $this.css('background-image');
            texts.toString();
            texts = texts.replace('url("','');
        var thumb = texts.replace('")','');
        var value = thumb;
        if (!$this.hasClass('disabled')) {
          timer = setTimeout(
            function () {
              var leftOpt = null,
                  leftCorner = 0,
                  left,
                  $window;

              if (type === 2) {
                $image.css({
                  'background': 'url("' + thumb + '") no-repeat center', //Background case
                  'background-size': 'initial'
                });
                $image.show();
              }

              $title.text(label);

              leftOpt = $this.offset().left;
              left = leftOpt + $this.width() / 2 - $element.width() / 2;
              $window = $(window);

              // the numbers (5 and 5) is magick constants for offset from left or right page
              if (left < 0) {
                left = 5;
              } else if (left + $element.width() > $window.width()) {
                left = $window.width() - $element.width() - 5;
              }
              // the numbers (6,  3 and 18) is magick constants for offset tooltip
              leftCorner = 0;
              if ($element.width() < $this.width()) {
                leftCorner = $element.width() / 2 - 3;
              } else {
                leftCorner = (leftOpt > left ? leftOpt - left : left - leftOpt) + $this.width() / 2 - 6;
              }
              $corner.css({ left: leftCorner });
              $element.css({
                left: left,
                top: $this.offset().top - $element.height() - $corner.height() - 18
              }).show();
            },
            200
          );
        }
      }, function () {
        $element.hide();
        clearTimeout(timer);
      });

      $(document).on('tap', function () {
        $element.hide();
        clearTimeout(timer);
      });
    }
    
    var refreshCollection = function(arg){
      if (arg.length == 0) {
        $('.main .category-view').show();
        if (!($('body').hasClass('vendor') || $('body').hasClass('sale'))) {
          $('#pl-product-grid').hide();
        } else {
          var defaultSwatch = $('#default-swatch').text().toString();
          setTimeout(function(){
            jQuery('#bc-sf-filter-products .swatch-option.image').each(function(i,e){
              var newswatch = defaultSwatch.replace("swatch-red", $(e).data('swatch'));
              var swatchbg = 'background-image: url('+newswatch+')';
              $(e).attr('style',swatchbg).attr('option-tooltip-thumb',newswatch);
              swatchtooltip($(e));
            });
//             filswatchtooltip($('.bc-sf-filter-option-swatch-image'));
          },1000);
        }
        setTimeout(function(){
//           filswatchtooltip($('.bc-sf-filter-option-swatch-image'));
        },1000);
      } else {
        $('#pl-product-grid').show();
        $('.main .category-view').hide()
        var defaultSwatch = $('#default-swatch').text().toString();
        setTimeout(function(){
          jQuery('#bc-sf-filter-products .swatch-option.image').each(function(i,e){
            var newswatch = defaultSwatch.replace("swatch-red", $(e).data('swatch'));
            var swatchbg = 'background-image: url('+newswatch+')';
            $(e).attr('style',swatchbg).attr('option-tooltip-thumb',newswatch);
            swatchtooltip($(e));
          });
//           filswatchtooltip($('.bc-sf-filter-option-swatch-image'));
        },1000);
      }
    }

    if ($('body').hasClass('template-collection') || $('body').hasClass('template-search')) {
      refreshCollection(window.location.search);
      $(document).on("click",function(e,d){
        var warg = window.location.search;
        refreshCollection(warg);
      });
      $(document).on('change','.collection-sort__input',function(){
        $(document).trigger('click');
      });
//       filswatchtooltip($('.bc-sf-filter-option-swatch-image'));
      $(document).trigger('click');
    }
    
    if ($('body').hasClass('template-product')) {
      swatchtooltip($('.swatch-option.color'));
      // compare prices show
      window.prodvardata = JSON.parse(document.getElementById('ProductJson-br-product-temp').innerHTML);
//       $('#ProductSelect-pl-products-temp').on('change',function(e){
//         var $this = $(this).find('option:selected');
//         var $val = $this.val();
//         var $list = window.prodvardata.variants;
//         for (var i=0; i<$list.length; i++) {
//           if ($val == $list[i].id){
//             var $newvar = $list[i];
//             var $newprice = $newvar.price / 100;
//             var $compprice = $newvar.compare_at_price / 100;
//             if($newprice < $compprice) {
//               $('.old-price').show();
//               $('#compprice').addClass('active').show();
//               $('#compprice-val').text($compprice.toFixed(2));
//             }else {
//               $('.old-price').hide();
//               $('#compprice-val').text($compprice.toFixed(2));
//             }
//           }
//         }
//       });
      
      // product detail and shipping calculator tab switches
      $('.data a.switch').click(function(e) {
        e.preventDefault();
        var $this = $(this);
        var $target = $($this.attr('href'));
        $this.parent().addClass('active').siblings('.data.item.title').removeClass('active');
        if (!$target.hasClass('shown')) {
          $target.show().addClass('shown').siblings('.data.item.content').hide().removeClass('shown');
        }
      });
      window.currcartitems = window.cartitems;
      // shipping calculator logic
      $('.action.ship-calc').click(function(e){
        cartitems = 0;
        var $zipInput = $('#pcte');
        var $ziVal = $zipInput.val();
        var isnum = /^\d+$/.test($ziVal);
        var ziplength = $ziVal.length;
        $('#custom-message-error').hide();
        if (isnum && ziplength == 4) {
          var $zip = parseInt($ziVal);
          // check if provincial or metro manila
          window.currAddress = '';
          if ($zip > 1820) {
            for (var i=1;i<79;i++) {
              $currprov = provzip[i].prov;
              $.each(provzip[i].zips,function(zip,zone){
                zip = parseInt(zip);
                if ($zip == zip) {
                  window.currZip = zip;
                  window.currAddress = zone + ', ' + $currprov;
                  i = 78;
                }
              });
            }
          } else {
            for (var i=1;i<18;i++) {
              $currcity = mmzip[i].city;
              $.each(mmzip[i].zips,function(zip,zone){
                zip = parseInt(zip);
                if ($zip == zip) {
                  window.currZip = zip;
                  window.currAddress = zone + ', ' + $currcity;
                  i = 18;
                }
              });
            }
          }
          cartitems = window.currcartitems + parseInt($('#Quantity').val());
          if (window.currAddress.length) {
            if ($zip < 1821) {
              if ( cartitems == 1 ){
                $shipcost = 'Php 190.00';
              } else if ( cartitems < 6 ) {
                $shipcost = 'Php 190.00';
              } else {
                $shipcost = 'Php 600.00';
              }
              $dateestimate = '3-5 days';
            } else {
              if ( cartitems == 1 ){
                $shipcost = 'Php 270.00';
              } else if ( cartitems < 6 ) {
                $shipcost = 'Php 270.00';
              } else {
                $shipcost = 'Php 800.00';
              }
              $dateestimate = '5-7 days';
            }
            $('#shipped-info').show().next().hide();
            $('#curr-address').text(window.currAddress);
            $('#date-estimate').text($dateestimate);
            $('#pl-shipping-amount').text($shipcost);
            $('#sip-tab-info').slideDown();
          } else {
            $('#custom-message-error').show();
            $('#sip-tab-info').hide();
          }
        } else {
          $('#custom-message-error').show();
          $('#sip-tab-info').hide();
        }
      });
      
      // change estimate place
      $('#shipped-info a.edit').click(function(e){
        e.preventDefault();
        $('#shipped-info').hide().next().show();
      });
      
      
      // contextualizing for easy use.
      // this function is recently added
      // to address the issue of wrong sizes
      // being added to cart
      var rawProductData = window.prodvardata,
          rpd = rawProductData,
          orgData = {
            colors: [],
            sizes: []
          };
      var variants = rpd.variants,
          l = variants.length,
          colorArr = orgData.colors,
          sizeArr = orgData.sizes
      if (rpd.type == "Shoes") {
        for (var i = 0; i < l; i++) { 
          var currVar = variants[i],
              varColor = currVar.option1,
              varSize = currVar.option2;
          if (currVar.available) {
             if (colorArr.indexOf(varColor) < 0) {
               colorArr.push(varColor);
               var obj = [{size: varSize,id: currVar.id}];
               sizeArr.push(obj);
             } else {
               var colorPos = colorArr.indexOf(varColor);
               sizeArr[colorPos].push({size: varSize,id: currVar.id});
             }
          }
        }
        // make data accessible globally
        window.orgData = orgData;
        // disable add to cart button by default
        var $ctabtn = $('AddToCart-br-product-temp');
        $ctabtn.attr('disabled',true);
        // use of data on line 245
      }else {
        for (var i = 0; i < l; i++) {
          var currVar = variants[i],
              varColor = currVar.option1;
          if (currVar.available && colorArr.indexOf(varColor) < 0) {
            var obj = [{color: varSize,id: currVar.id}];
                colorArr.push(obj);
          }
        }
        // make data accessible globally
        window.orgData = orgData;
        // disable add to cart button by default
        var $ctabtn = $('AddToCart-br-product-temp');
        $ctabtn.attr('disabled',true);
      }
      $(window).load(function(){
//         $('.color .swatch-option.available').first().trigger('click');
        $addToCartBtn.children().text('Add To Bag'); //changed by Rengie 21/Feb/19
      });
      
    }
    
    // newsletter signup submit
    $('#newsletter-validate-detail').on('submit',function(e){
      e.preventDefault();
      if ($('.subscribe .confirmation input').is(':checked')) {
        var $this = $('#newsletter-email-val');
        var $val = $this.val();
        $('#mce-EMAIL').val($val);
        $('#mc-embedded-subscribe-form').trigger('submit');
      } else {
        alert('Please tick Privacy Policy checkbox.')
      }
    });
    
    // account creation privacy policy
    $('#authenticationPopup input[type="submit"]').click(function(e){
      e.preventDefault();
      if ($('.fieldset .confirmation input').is(':checked')) {
        $('#form-validate').submit();
      } else {
        alert('Please tick Privacy Policy checkbox.');
      }
    });
    
    // RELATED PRODUCTS
    $.fn.pick = function(how_many) {
      var how_many = how_many || 4;
      // Picking random numbers without repeating. 
      var index_array = [];
      var original_obj_size = this.size();
      for (var i=0; i<original_obj_size; i++) {
        index_array.push(i);
      }
      //+ Jonas Raoni Soares Silva
      //@ http://jsfromhell.com/array/shuffle [rev. #1]
      var shuffle = function(v) {
        for (var j, x, i = v.length; i; j = parseInt(Math.random() * i), x = v[--i], v[i] = v[j], v[j] = x);
        return v;
      };
      function theshuffle(array) {
        var cI = array.length, tV, rI;
        while (0 !== cI) {
          rI = Math.floor(Math.random() * cI);
          cI -= 1;
          tV = array[cI];
          array[cI] = array[rI];
          array[rI] = tV;
        }

        return array;
      }
      var new_index_array = theshuffle(index_array)
      new_index_array.slice(0,how_many);
      

      // Ditching unpicked elements and removing those from the returned set.
      return this.each(function(i) {
         if ($.inArray(i,new_index_array) === -1) {
            $(this).remove();
         }
      }).filter(function() {
        if (this.parentNode === null) {
          return false;
        }
        else {
          return true;
        }
      });

    };
    
    jQuery.fn.yesshuffle = function () {
      var j;
      for (var i = 0; i < this.length; i++) {
        j = Math.floor(Math.random() * this.length);
        $(this[i]).before($(this[j]));
      }
      return this;
    };
    
    $('.products-related .product-item').pick(4);
    $('.products-related .product-item').yesshuffle();
    
    window.prodlistbuilt = false;
    
    // 
    $(window).on("load",function(){  
      var elem = document.querySelector('.product-items');
      if(elem !== null){
        if($('#bc-sf-filter-bottom-pagination').length){
          /*var infScroll = new InfiniteScroll( elem, {
            // options
            path: '.pl-next',
            append: '.product-item',
            history: false
          });*/
          //var $con = $('#bc-sf-filter-products.product-items');
          //$con.infiniteScroll({
          // path: '.pl-next',
          // append: '.product-item',
          // history: false
          //});
        }
        $("#bc-sf-filter-tree").addClass("filter-options");
      
        $(".filter-title").on("click",function(){
            $("body").toggleClass("filter-active");
          $(".block.filter").toggleClass("active");
        });
      }
      $(document).trigger('click');
      
      if($('body').hasClass('template-cart')) {
        var $promototaltext = $('.saso-cart-total').text();
        var $carttotal = $promototaltext.replace(' PHP','');
        var srp = parseFloat($carttotal.replace('₱','').replace(',',''));
        var vatablesale = parseFloat((srp/1.12).toFixed(2));
        var tax = parseFloat((vatablesale*0.12).toFixed(2));
        var sstotal = '₱'+ vatablesale.toLocaleString('en');
        var taxtotal = '₱'+ tax.toLocaleString('en');
        if ($promototaltext.length > 1){
          $('#saso-subtotal').text(sstotal);
          $('#tax-total').text(taxtotal);
          $('#est-total').text($carttotal);
          //temp 
          var $sslsa = $('.saso-summary-line-spend-amount'),
            sstext = $sslsa.html();
//           sstext = sstext.replace('undefined','Payday Yay!');
//           $sslsa.html(sstext);
        }
      }
      
    });
    
    // store finder page
//     $('.locator_arrow').click(function(e){
//       $(this).toggleClass('arrow_active').closest('.today_schedule').next().slideToggle();
//     });
    
    // account dashboard toggle for mobile
    $('.title.block-collapsible-nav-title').click(function(){
      var $this = $(this);
      $this.toggleClass('active').next().toggleClass('active');
    });
    
    $('.address-new-toggle').click(function(){
//       $('#AddressNewForm').slideDown(300)
    });
    
    
    
//     if ($('body').hasClass('template-cart')){
//       // declare variables
//       window.xcartItems = [];
//       var currentPromoName = 'Buy 2 Get 1',
//           promoAppliesToCart = false,
//           lowestPrice = 0,
//           lowestPricedItems = [],
//           lowestPricedItemsCount = 0,

//           // regular items
//           preReqCount = 0,
//           regularItems = [],
//           regularPricesArr = [],

//           // sale items
//           saleItems = [],
//           salePricesArr = [],

//           // entitled items
//           entitledItems = [],
//           entitledItemCount = 0,
//           entitledPricesArr = [],

//           // cart price data
//           discountPrice = 0,
//           baseSubtotal = 0,
//           entitledCount = 0,
//           totalCartQuantity = 0,
//           discountedSubtotal = 0,
//           itemsToDiscount = 0;
        
//      // sorting function: arrange items according to property
//      function dynamicSort(property) {
//        var sortOrder = 1;
//        if(property[0] === "-") {
//          sortOrder = -1;
//          property = property.substr(1);
//        }
//        return function (a,b) {
//          var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
//          return result * sortOrder;
//        }
//      }

//       // loop through cart line items 
//       // and push them into window.xcartItems 
//       $('.cart-row .item').each(function(i,e){
//         $el = $(e);
//         item = {
//           product_id: $el.data('productid'),
//           variant_id: $el.data('variantid'),
//           tags: $el.data('tags').toLowerCase(),
//           name: $el.data('title'),
//           price: $el.data('price'),
//           quantity: parseInt($el.data('qty')),
//           row: $el.data('row')
//         }
//         isRegularItem = item.tags.indexOf("regular");
//         if(isRegularItem > -1){
//           regularItems.push(item);
//           preReqCount += item.quantity;
//         } else {
//           saleItems.push(item);
//         }
//         totalCartQuantity += item.quantity;
//         window.xcartItems.push(item);
//       });

//       // sort from lowest to highest price
//       regularItems.sort(dynamicSort("price"));
//       saleItems.sort(dynamicSort("price"));
//       window.xcartItems.sort(dynamicSort("price"));
//       lowestPrice = window.xcartItems[0].price;

//       // check if there are enough prerequisite items in cart
//       var discountGroups = Math.trunc(totalCartQuantity/3); // a discount group needs 2 prerequisites and 1 entitled item
//       var discountableItems = Math.trunc(preReqCount/2);
//       var preReqModulo = preReqCount%2;

//       // push regular prices into array for comparison
//       for (var i = 0; i < regularItems.length; i++) {
//         for (var j = 0; j < regularItems[i].quantity; j++){
//           regularPricesArr.push(regularItems[i].price);
//         }
//       }

//       // push sale prices into array for comparison
//       for (var i = 0; i < saleItems.length; i++) {
//         for (var j = 0; j < saleItems[i].quantity; j++){
//           salePricesArr.push(saleItems[i].price);
//         }
//       }



//       // there are more than 2 Regular Items in the cart
//       if (preReqCount > 2) {
//         $('#checkout-button').attr('href','/checkout?discount=FP7B2G1');
//         $('#checkout-form').attr('action','/checkout?discount=FP7B2G1');
//         var markup = '<tr class="totals"><th colspan="1" style="" class="mark" scope="row"><div class="saso-summary">'+
//                 '<span class="saso-summary-line-buyxgety">Buy 2 Get 1:<br>Discount will apply on checkout.</span>'+
//           '</div></th></tr>';
//         $(markup).insertBefore($('.totals-tax'));
//       } else {
//         if (discountableItems > 0) {
//           // loop through cart items to check for entitled items
//           for (var i = 0; i < window.xcartItems.length; i++) {
//             var XItem = window.xcartItems[i];
//             var XPrice = XItem.price;
//             var XTags = XItem.tags
//             // 
//             if(i == preReqCount) break;
//             if(entitledItems.length != discountableItems){
//               if(XPrice <= regularPricesArr[entitledItems.length]){
//                 if (regularItems[entitledItems.length] !== XItem) {
//                   entitledItems.push(XItem);
//                 }
//               }
//             } else {
//               break;
//             }
//           }
//           // if there are 
//           if(entitledItems.length){
//             var licount = 0,
//                 discountPrice = 0;
//                 discountItemsArr = 0;
//             for(; licount < discountGroups; licount++){
//               var liQuantity = entitledItems[licount].quantity;
//               for(var innerCounter = 0; innerCounter < liQuantity; innerCounter++){
//                 if (discountItemsArr == discountGroups) break;
//                 var markup = '<tr class="totals">'+
//                     '<th colspan="1" style="" class="mark" scope="row">'+
//                     '<div class="saso-summary">'+
//                     '<span class="saso-summary-line-buyxgety">{currentPromoName}:<br>{itemTitle}</span>'+
//                     '</div>'+
//                     '</th>'+
//                     '<td class="amount">'+
//                     '<span class="price">'+
//                     '<span class="saso-price">- ₱{itemPrice}</span>'+
//                     '</span>'+
//                     '</td>'+
//                     '</tr>';
//                 pp = parseFloat((parseInt(entitledItems[licount].price)/100).toFixed(2));
//                 pq = pp.toFixed(2).toLocaleString('en');
//                 markup = markup.replace(/{currentPromoName}/g, currentPromoName);
//                 markup = markup.replace(/{itemTitle}/g, entitledItems[licount].name);
//                 markup = markup.replace(/{itemPrice}/g, pq);
//                 $(markup).insertAfter($('.totals.sub.incl'));
//                 ePrice = entitledItems[licount].price;
//                 discountPrice += ePrice;
//                 discountItemsArr++;
//               }
//             }
//             discountPrice /= 100;
//             var sstotaltext = $('#saso-total').prev('.saso-cart-original-total').text(),
//                 srp = parseFloat(sstotaltext.replace('₱','').replace(',','')),
//                 esttotal = (srp - discountPrice).toFixed(2),
//                 totalDiscount = '₱'+ (discountPrice).toFixed(2),
//                 vatablesale = parseFloat((esttotal/1.12).toFixed(2)),
//                 tax = parseFloat((vatablesale*0.12).toFixed(2)),
//                 sstotal = '₱'+ vatablesale.toLocaleString('en'),
//                 taxtotal = '₱'+ tax.toLocaleString('en');

//               $('#saso-subtotal').text(sstotal);
//               $('#saso-total,#est-total').text('₱' + esttotal.toLocaleString('en'));
//               $('#tax-total').text(taxtotal);
//               $('.saso-cart-original-total').css('text-decoration','line-through');

//               var discountTotes = '<tr class="totals">'+
//                   '<th colspan="1" style="" class="mark" scope="row"><div class="saso-summary">'+
//                   '<span class="saso-summary-line-buyxgety">Total Discount:</span>'+
//                   '</div></th>'+
//                   '<td class="amount">'+
//                   '<span class="price">'+
//                   '<span class="saso-price">- {totalDiscount}</span>'+
//                   '</span>'+
//                   '</td>'+
//                   '</tr>';
//               discountTotes = discountTotes.replace(/{totalDiscount}/g, totalDiscount);
//               $(discountTotes).insertBefore($('.totals-tax'));
//             $('#checkout-button').attr('href','/checkout?discount=FP7B2G1');
//             $('#checkout-form').attr('action','/checkout?discount=FP7B2G1');
//           } else {
//             $('#checkout-button').attr('href','/checkout?discount=REGULARORDER');
//             $('#checkout-form').attr('action','/checkout?discount=REGULARORDER');
//           }
//         }
//       }
//     }
    
    
    /* bogo promo test */
    function getUrlVars() {
      var vars = {};
      var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
      });
      return vars;
    }
    // sorting function: arrange items according to property
    function dynamicSort(property) {
      var sortOrder = 1;
      if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function (a,b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
      }
    }
    
    if (getUrlVars()['xmasbogo'] == 'test'){
      var in30Minutes = 1/48;
      Cookies.set('bogotest', 'test', { expires: in30Minutes });
    }
//     if(Cookies.get('bogotest') == 'test'){
//       if ($('body').hasClass('template-cart')){
//         // declare variables
//         window.xcartItems = [];
//         P = {
//           currentPromoName: 'Buy 1 Get 1 @ 50%',
//           promoAppliesToCart: false,
//           lowestPrice: 0,
//           lowestPricedItems: [],
//           lowestPricedItemsCount: 0,
//           allPricesArr: [],
//           // regular items
//           preReqCount: 0,
//           regularItems: [],
//           regularPricesArr: [],
//           // sale items
//           saleItems: [],
//           salePricesArr: [],
//           // entitled items
//           entitledItems: [],
//           entitledItemCount: 0,
//           entitledPricesArr: [],
//           // cart price data
//           discountPrice: 0,
//           baseSubtotal: 0,
//           entitledCount: 0,
//           totalCartQuantity: 0,
//           discountedSubtotal: 0,
//           itemsToDiscount: 0
//         };

//         // loop through cart line items 
//         // and push them into window.xcartItems 
//         $('.cart-row .item').each(function(i,e){
//           var $el = $(e);
//           var item = {
//             product_id: $el.data('productid'),
//             variant_id: $el.data('variantid'),
//             tags: $el.data('tags').toLowerCase(),
//             name: $el.data('title'),
//             price: $el.data('price'),
//             quantity: parseInt($el.data('qty')),
//             row: $el.data('row')
//           },
//           isRegularItem = item.tags.indexOf("regular");
//           if(isRegularItem > -1){
//             P.regularItems.push(item);
//             P.preReqCount += item.quantity;
//           } else {
//             P.saleItems.push(item);
//           }
//           P.totalCartQuantity += item.quantity;
//           window.xcartItems.push(item);
//         });
        
        
//         // sort from lowest to highest price
//         P.regularItems.sort(dynamicSort("price"));
//         P.saleItems.sort(dynamicSort("price"));
//         window.xcartItems.sort(dynamicSort("price"));
//         P.lowestPrice = window.xcartItems[0].price;

//         // push regular prices into array for comparison
//         for (var i = 0; i < P.regularItems.length; i++) {
//           for (var j = 0; j < P.regularItems[i].quantity; j++){
//             P.regularPricesArr.push(P.regularItems[i].price);
//           }
//         }

//         // push sale prices into array for comparison
//         for (var i = 0; i < P.saleItems.length; i++) {
//           for (var j = 0; j < P.saleItems[i].quantity; j++){
//             P.salePricesArr.push(P.saleItems[i].price);
//           }
//         }
        
//         // push sale prices into array for comparison
//         for (var i = 0; i < window.xcartItems.length; i++) {
//           for (var j = 0; j < window.xcartItems[i].quantity; j++){
//             P.allPricesArr.push(window.xcartItems[i].price);
//           }
//         }
        
//         P.regularPricesArr.reverse();
//         P.salePricesArr.reverse();
//         P.allPricesArr.reverse();
        
        
//         var aPL = P.allPricesArr.length - 1;
//         var markup = '<tr class="totals"><th colspan="1" style="" class="mark" scope="row"><div class="saso-summary">'+
//             '<span class="saso-summary-line-buyxgety" style="color:#e24057">'+ P.currentPromoName +':<br>Discount will apply on checkout.</span>'+
//           '</div></th></tr>';
        
//         var $checkoutBtn = $('#checkout-button');
//         var $checkoutForm = $('#checkout-form');
//         if(P.preReqCount >= 1 && P.regularPricesArr[0] >= P.allPricesArr[aPL] && P.totalCartQuantity < 4 && P.totalCartQuantity > 1){
//           $checkoutBtn.attr('href','/checkout?discount=FP8BG1A');
//           $checkoutForm.attr('action','/checkout?discount=FP8BG1A');
//           $(markup).insertBefore($('.totals-tax'));
//         } else if (P.preReqCount >= 3 && P.regularPricesArr[2] >= P.allPricesArr[5] && P.totalCartQuantity >= 6){
//           $checkoutBtn.attr('href','/checkout?discount=FP8BG1C');
//           $checkoutForm.attr('action','/checkout?discount=FP8BG1C');
//           $(markup).insertBefore($('.totals-tax'));
//         } else if (P.preReqCount >= 2 && P.regularPricesArr[1] >= P.allPricesArr[2] && P.totalCartQuantity >= 4){
//           $checkoutBtn.attr('href','/checkout?discount=FP8BG1B');
//           $checkoutForm.attr('action','/checkout?discount=FP8BG1B');
//           $(markup).insertBefore($('.totals-tax'));
//         } else {
//           $('#checkout-button').attr('href','/checkout?discount=REGULARORDER');
//           $('#checkout-form').attr('action','/checkout?discount=REGULARORDER');
//         }
        
        
      
//       }
//     }
    
    
    
    
    
    
    
    
    //header promo modal
    $('.modalLink').click(function() {
      $('.promoModal').show();
      $('html').css("overflow", "hidden");
    })
    
    $('.promoModal-close-button-bg').click(function() {
      $('.promoModal').hide();
      $('html').removeAttr("style");
    })
    
    var modal = document.getElementById('promoModalID');


    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
        $('html').removeAttr("style");
      }else{
        jQuery.noop();
      }
    }
    
    

  });
  
   //women or men category dropdown
  $('.featuredSection_catButton').click(function() {
    $('.featuredSection_dropDown').slideToggle();
  });
  
  $('.featured_Selection').hover(function() {
    var $this = $(this);
    var text = $this[0].innerText.toLowerCase();
    $('.featuredSection_newArrival').toggleClass('hover_DispNone').toggleClass('hover_DispInline');
    var showImg = $('*[data-hover="'+text+'"]').toggleClass('hover_DispInline');
  });
  
  $('.womenProd_arrow').hover(function() {
    var $this = $(this);
    $this.children('.current_left_arrow').toggleClass('hover_DispInline').toggleClass('hover_DispNone');
    $this.children('.hidden_left_arrow').toggleClass('hover_DispInline');
  });
  
  $('.womenProd_arrow').hover(function() {
    var $this = $(this);
    $this.children('.current_right_arrow').toggleClass('hover_DispInline').toggleClass('hover_DispNone');
    $this.children('.hidden_right_arrow').toggleClass('hover_DispInline');
  });
})(jQuery);
